<template>
  <div>
    <div :class="`${isLanding ? 'form-landing' : 'p-2'}`">
      <vx-card :class="!showPanel ? 'painel-no-border' : 'painel-border'">
        <div class="text-center mb-5" v-if="hideLogo != true">
          <img
            v-if="logo != '' && isInterno === false && !isLanding"
            :src="logo"
            width="70%"
            style="display: inline; max-width: 250px"
          />
        </div>
        <div
          v-if="isPropostaConsultor && dadosConsultor"
          class="text-center mb-10"
        >
          <vx-card>
            <h5 class="text-left mb-5">Consultor</h5>
            <div class="vx-row">
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <img
                  src="data:image/png;base64,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"
                  alt="Avatar"
                  style="width: 32px; height: 32px; display: inline"
                  class="rounded-circle avatar border border-white"
                />

                <div>
                  {{ dadosConsultor.nome }}
                </div>
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <div>
                  <feather-icon
                    :icon="'MailIcon'"
                    class="inline-flex rounded-full"
                    :style="{ background: `rgba(var(--vs-black),.15)` }"
                  ></feather-icon>
                </div>
                {{ dadosConsultor.email }}
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <div>
                  <feather-icon
                    :icon="'PhoneIcon'"
                    class="inline-flex rounded-full"
                    :style="{ background: `rgba(var(--vs-black),.15)` }"
                  ></feather-icon>
                </div>
                {{ dadosConsultor.celular }} / {{ dadosConsultor.telefone }}
              </div>
            </div>
          </vx-card>
        </div>
        <!-- INICIO ESCOLHA CORRETORA -->
        <form
          v-if="
            $can('Permitir alterar Corretora da proposta', 'Cotações') &&
            passo == 0 &&
            isInterno == true &&
            (regionais.length > 1 || divisoes.length > 1)
          "
          role="form"
          @submit.stop.prevent="onSubmit"
          autocomplete="nope"
        >
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <span>Selecione Corretora</span>
              <v-select
                :options="regionais"
                name="Corretora"
                id="Corretora"
                v-model="form.regional"
                :state="validateState('Corretora')"
                :class="validateClass('Corretora')"
                @input="buscaDivisoes()"
              ></v-select>
            </div>
          </div>
        </form>
        <!-- FIM ESCOLHA CORRETORA -->

        <!-- // INICIO PÁGINA DA COTAÇÃO -->
        <form
          v-if="passo === 1"
          role="form"
          @submit.stop.prevent
          autocomplete="nope"
        >
          <!-- ?? -->
          <input type="password" style="display: none" readonly/>
          <!-- ?? -->

          <!-- INÍCIO SEGUNDO PASSO -->
          <div v-if="!thirdStep">
            <div class="form-part-title mt-6 mb-6">
              <span>Dados da Proposta</span>
            </div>

            <!-- INÍCIO DADOS DA PROPOSTA -->
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Tipo de Proposta" class="vs-select--label"
                >Tipo de Proposta</label
                >
                <v-select
                  :options="listTiposProposta"
                  name="Tipo de Proposta"
                  id="Tipo de Proposta"
                  v-model="form.tipoProposta"
                  v-validate="{ required: true }"
                  label="label"
                  placeholder="Selecione o tipo"
                  :state="validateState('Tipo de Proposta')"
                  :class="validateClass('Tipo de Proposta')"
                ></v-select>
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Tipo de Contrato" class="vs-select--label"
                >Tipo de Contrato</label
                >
                <v-select
                  :options="listTiposContrato"
                  name="Tipo de Contrato"
                  id="Tipo de Contrato"
                  v-model="form.tipoContrato"
                  placeholder="Selecione o tipo de contrato"
                  v-validate="{ required: true }"
                  label="label"
                  :state="validateState('Tipo de Contrato')"
                  :class="validateClass('Tipo de Contrato')"
                ></v-select>
              </div>

              <div class="vx-col sm:w-1/4 w-full">
                <label>Início Vigência</label>
                <div>
                  <flat-pickr
                    name="Início Vigência"
                    class="input-data-ativacao"
                    id="Início Vigência"
                    v-model="form.inicioVigencia"
                    v-validate="{ required: true }"
                    :state="validateState('Início Vigência')"
                    :class="validateClass('Início Vigência')"
                    :config="{ ...configdateTimePickerDay }"
                    placeholder="DD/MM/AAAA"
                  />
                </div>
              </div>

              <div class="vx-col sm:w-1/4 w-full">
                <label>Fim Vigência</label>
                <div>
                  <flat-pickr
                    name="Fim Vigência"
                    class="input-data-ativacao"
                    id="Fim Vigência"
                    v-model="form.fimVigencia"
                    v-validate="{ required: true }"
                    :state="validateState('Fim Vigência')"
                    :class="validateClass('Fim Vigência')"
                    :config="{
                      ...configdateTimePickerDay,
                      minDate: minDateFimVigencia,
                    }"
                    placeholder="DD/MM/AAAA"
                    disabled
                  />
                </div>
              </div>
            </div>
            <!-- FIM DADOS DA PROPOSTA -->

            <!-- INÍCIO DADOS DO SEGURADO -->
            <div class="form-part-title mb-6">
              <span>Dados do Segurado</span>
            </div>

            <div class="vx-row mb-4">
              <div class="vx-col w-full sm:w-5/12">
                <vs-input
                  class="w-full"
                  label="Nome Completo / Nome Social"
                  v-model="form.nome"
                  name="Nome"
                  id="Nome"
                  v-validate="{ required: true }"
                  :state="validateState('Nome')"
                  :class="validateClass('Nome')"
                  @blur.native="salvaProspect()"
                />
              </div>

              <div class="vx-col w-full sm:w-2/12 checkBoxNomeSocial">
                <vs-checkbox v-model="form.nomeSocial">
                  Nome Social?
                </vs-checkbox>
              </div>

              <div v-if="form.nomeSocial" class="vx-col w-full sm:w-5/12">
                <vs-input
                  class="w-full"
                  label="Nome Civil"
                  v-model="form.nomeCivil"
                  name="Nome Civil"
                  id="Nome Civil"
                  v-validate="'required'"
                  :state="validateState('Nome Civil')"
                  :class="validateClass('Nome Civil')"
                  @blur.native="salvaProspect()"
                />
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col w-full sm:w-1/4">
                <vs-input
                  v-model="form.cpfcnpj"
                  class="w-full"
                  label="CPF-CNPJ"
                  id="cpfCnpjInput"
                  name="CPF-CNPJ"
                  v-validate="{ required: true, min: escolherCPFCNPJMin }"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  :state="validateState('CPF-CNPJ')"
                  :class="validateClass('CPF-CNPJ')"
                />
              </div>
              <div class="vx-col w-full sm:w-1/4">
                <vs-input
                  class="w-full"
                  label="E-mail"
                  v-model="form.email"
                  name="Email"
                  v-validate="{ required: true, email: true }"
                  @blur.native="salvaProspect()"
                  :state="validateState('Email')"
                  :class="validateClass('Email')"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <label for="Celular" class="vs-select--label">Celular</label>
                <the-mask
                  mask="(##) #####-####"
                  id="Celular"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.celular"
                  name="Celular"
                  :masked="true"
                  v-validate="{ required: true, min: 15 }"
                  @blur.native="verificaCelular(form.celular), salvaProspect()"
                  :state="validateState('Celular')"
                  :class="validateClass('Celular')"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <label for="Telefone" class="vs-select--label">Telefone</label>
                <the-mask
                  :mask="['(##) ####-####', '(##) #####-####']"
                  id="Telefone"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.telefone"
                  name="Telefone"
                  :masked="true"
                  v-validate="{ min: 14 }"
                  :state="validateState('Telefone')"
                  :class="validateClass('Telefone')"
                />
              </div>
            </div>

            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/4 w-full">
                <label for="Estado" class="vs-select--label">CEP</label>
                <vs-input
                  class="w-full"
                  name="Cep"
                  id="Cep"
                  @keyup.native="keymonitor"
                  v-model="cep"
                  v-validate="{ required: true, min: 10 }"
                  :state="validateState('Cep')"
                  :class="validateClass('Cep')"
                  v-mask="'##.###-###'"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <label for="Endereco" class="vs-select--label">Endereço</label>
                <vs-input
                  v-model="endereco"
                  class="w-full"
                  id="Endereco"
                  name="Endereco"
                  :state="validateState('Endereco')"
                  :class="validateClass('Endereco')"
                  v-validate="{ required: true }"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <label for="numero" class="vs-select--label">Número</label>
                <vs-input
                  v-model="form.numero"
                  class="w-full"
                  id="numero"
                  name="numero"
                  :state="validateState('numero')"
                  :class="validateClass('numero')"
                  v-validate="{ required: true }"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <label for="complemento" class="vs-select--label"
                >Complemento</label
                >
                <vs-input
                  v-model="form.complemento"
                  class="w-full"
                  id="complemento"
                />
              </div>
            </div>

            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/3 w-full">
                <label for="Bairro" class="vs-select--label">Bairro</label>
                <vs-input
                  v-model="bairro"
                  class="w-full"
                  id="Bairro"
                  name="Bairro"
                  :state="validateState('Bairro')"
                  :class="validateClass('Bairro')"
                  v-validate="{ required: true }"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <label for="Estado" class="vs-select--label">Estado</label>
                <v-select
                  :options="estados"
                  name="Estado"
                  id="Estado"
                  autocomplete="off"
                  @input="
                    buscaDadosSelectsCidades(
                      'domMunicipio',
                      'cidades',
                      'nomeCidade',
                      'idCidade',
                    ),
                      selecionaEstado()
                  "
                  v-model="estado"
                  placeholder="Selecione o Estado"
                  v-validate="{ required: true }"
                  label="label"
                  :state="validateState('Estado')"
                  :class="validateClass('Estado')"
                ></v-select>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <label for="Cidade" class="vs-select--label">Cidade</label>
                <v-select
                  :options="cidades"
                  name="Cidade"
                  id="Cidade"
                  @input="selecionaCidade()"
                  v-model="cidade"
                  placeholder="Selecione a Cidade"
                  v-validate="{ required: true }"
                  label="label"
                  :state="validateState('Cidade')"
                  :class="validateClass('Cidade')"
                ></v-select>
              </div>
            </div>

            <!-- FIM DADOS DO SEGURADO -->

            <!-- INÍCIO DADOS DO VEÍCULO RCVAT -->
            <div class="form-part-title mt-6 mb-6">
              <span>Dados do Veículo</span>
            </div>

            <formProdutosRcvat
              :dadosProposta="dadosProposta"
              :quotationData="quotationData"
              :create="true"
              @salvarProdutosRcvat="saveProductsRcvat"
            ></formProdutosRcvat>

            <!-- FIM DADOS DO VEÍCULO RCVAT -->

            <!-- INÍCIO AGRAVOS -->

            <div v-if="listAgravos.length" class="form-part-title">
              <span>Questionário de Avaliação de Risco</span>
            </div>

            <AgravosForm
              :listAgravos="listAgravos"
              :formData="form"
              parent="1"
              ref="AgravosForm"
            />

            <vs-alert
              v-if="validaImplementosAgregados"
              color="danger"
              title="Atenção!!"
              active="true"
              class="my-3"
              style="height: auto !important"
            >
              <ul>
                <li class="mb-2">
                  {{ msgValidacaoImplementoAgregado }}
                </li>
              </ul>
            </vs-alert>

            <ErrorsAlert :errors="errors"/>

            <!-- FIM AGRAVOS -->

            <!-- INÍCIO AÇÕES -->

            <div
              class="vx-row"
              style="flex-wrap: nowrap"
              :class="fixedButton == true ? 'fixed-buttons' : ''"
            >
              <div
                class="vx-col w-full text-left mt-2 mb-2"
                v-if="
                  isInterno == true &&
                  (regionais.length > 1 || divisoes.length > 1)
                "
              >
                <vs-button
                  :color="colorButton ? `#${colorButton}` : 'dark'"
                  type="border"
                  @click="voltarPasso()"
                >
                  Voltar
                </vs-button
                >
              </div>

              <div class="vx-col w-full text-right">
                <button
                  :color="colorButton ? `#${colorButton}` : 'success'"
                  type="filled"
                  @click="buscar"
                  :disabled="btnDisabled2"
                  class="mt-2 mb-2 botaoContratarAgora"
                  :class="insideApp == true || isLanding ? 'w-full' : ''"
                  :pill="isLanding ? true : false"
                >
                  <span>Gerar Proposta</span>
                  <img
                    v-if="isLanding"
                    src="../../assets/images/svg/iconArrowRight.svg"
                  />
                </button>
              </div>
            </div>
          </div>
          <!-- FIM SEGUNDO PASSO -->

          <!-- INÍCIO TERCEIRO PASSO -->
          <div v-if="thirdStep">
            <CarregamentosForm
              :formData="form"
              ref="CarregamentosForm"
              parent="1"
              @recalcular="recalcularValorProdutos = true"
            />

            <div class="w-full" :style="`${isInterno ? '' : 'display: none'}`">
              <!-- // SEGURADORA -->
              <h6 class="mt-5">
                Total Anual:
                {{ total | currency }}
              </h6>
            </div>

            <div
              class="vx-row"
              :class="fixedButton == true ? 'fixed-buttons' : ''"
            >
              <div class="vx-col sm:w-1/2 text-left">
                <vs-button
                  :color="colorButton ? `#${colorButton}` : 'dark'"
                  @click.stop.prevent="voltar()"
                  type="border"
                  class="mt-2 mb-2"
                  :class="insideApp == true ? 'w-full' : ''"
                >Voltar
                </vs-button
                >
              </div>
              <div class="vx-col sm:w-1/2 text-right">
                <vs-button
                  v-if="recalcularValorProdutos"
                  color="primary"
                  @click.stop.prevent="buscar"
                  type="gradient"
                  class="mt-2 mb-2 mr-2"
                >Recalcular valor dos produtos
                </vs-button
                >
                <vs-button
                  v-if="generateQuotation"
                  :color="colorButton ? `#${colorButton}` : 'success'"
                  @click.stop.prevent="(btnBlock = true), GerarPropostaSite()"
                  type="gradient"
                  class="mt-2 mb-2"
                  :class="insideApp == true ? 'w-full' : ''"
                  :disabled="btnBlock || recalcularValorProdutos"
                >Concluir proposta
                </vs-button
                >
              </div>
            </div>
          </div>
          <!-- INÍCIO TERCEIRO PASSO -->

          <!-- FIM AÇÕES -->
        </form>

        <vs-button
          v-if="insideApp"
          color="dark"
          type="border"
          :class="insideApp == true ? 'w-full' : ''"
          :href="{
            url: `${getWindow().replace('adm.', 'app.')}/?idEmpresa=${
              form.idEmpresa
            }`,
          }"
        >Voltar para o Login
        </vs-button
        >
        <div
          v-if="
            $can('Permitir alterar Corretora da proposta', 'Cotações') &&
            passo == 0 &&
            isInterno == true &&
            (regionais.length > 1 || divisoes.length > 1)
          "
          class="vx-row"
        >
          <div class="vx-col w-full text-right mt-5">
            <vs-button color="success" @click="onSubmit()">Avançar</vs-button>
          </div>
        </div>
      </vx-card>

      <!-- INÍCIO MODAL VALIDAÇÃO EMAIL -->
      <Modal
        class="holamundo"
        title="Atenção!"
        :active.sync="openEscolherAssociado"
      >
        <vs-alert
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          color="danger"
        >
          Foram encontrados um ou mais segurados / prospects com esse email,
          você pode escolher um para continuar ou clicar em nenhum destes e
          criar um novo registro!
        </vs-alert>
        <table class="table table-bordered">
          <tr v-for="(item, index) in associadoEncontrado" :key="index">
            <td :data="item.nome">
              <label>NOME:</label> {{ item.nome }}
              <br/>
              <label>CELULAR:</label>{{ item.celular }}<br/>
              <label>SITUAÇÃO:</label
              >{{ item.situacao == null ? 'Prospect' : item.situacao }}
            </td>
            <td>
              <vs-button
                @click="selecionaPorEmail(item)"
                type="gradient"
                color="success"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </vs-button>
            </td>
          </tr>
          <tr class="con-vs-alert my-3 con-vs-alert-danger">
            <td>Nenhum destes</td>
            <td>
              <vs-button
                @click="selecionaPorEmail({})"
                type="gradient"
                color="success"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </vs-button>
            </td>
          </tr>
        </table>
      </Modal>
      <!-- FIM MODAL VALIDAÇÃO EMAIL -->

      <!-- modal data saída nf invalido -->
      <Modal
        class="holamundo"
        title="Data de saída da nota fiscal inválida"
        :active.sync="modalInfoDataSaidaNf"
        @close="modalInfoDataSaidaNf = false"
      >
        A data de saída da nota físcal é inválida, a saída do veículo deve ter
        no máximo 3 dias úteis.

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="modalInfoDataSaidaNf = false"
              type="gradient"
              color="warning"
              class="mt-5"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Entendi
            </vs-button>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
const {TIPO_APOLICE} = require('./../../../common/constant/tipo_apolice');
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import functions from '../../utils/functions';
import {Money} from 'v-money';
import jwt from 'jsonwebtoken';
import cartaoCredito from './../forms/FormCartaoCredito.vue';
import FormComplemento from '../forms/FormComplemento.vue';
import formDesconto from '../forms/formDesconto.vue';
import dateConversion from '../../utils/dateConversion';
import FormNovoValorProduto from '../forms/FormNovoValorProduto.vue';
import {consultaPlaca, buscarPlacaBaseBP} from '../../services/cotacao';
import cpfcnpj from '../../services/cpfCnpj';
import flatPickr from 'vue-flatpickr-component';
import {Portuguese} from 'flatpickr/dist/l10n/pt.js';
import notify from '../../utils/notify.js';
import formProdutosRcvat from '../forms/formProdutosRcvat.vue';

// Nova Cotação Seguradoa V2
import NCSv2_utils from '../menu/nova-cotacao-seguradora/utils';
import CarregamentosForm from '../menu/nova-cotacao-seguradora/components/carregamentosForm';
import AgravosForm from '../menu/agravos/agravosForm.vue';
import ErrorsAlert from '../../components/ErrorsAlert';
import quotationApi from '../../services/quotation-api';
import Modal from '../../components/Modal.vue';

export default {
  name: 'NovaProposta',
  props: ['idEmpresaProps', 'isLanding'],
  computed: {
    AlterarValorProduto() {
      const bemProtege = this.verificaEmpresa();
      if (bemProtege) {
        return true;
      } else {
        return false;
      }
    },
    seletorTiposProposta() {
      return this.codigoSituacaoPlaca === '998'
        ? this.tiposPropostaReduzidos
        : this.tiposProposta;
    },

    // SEGURADORA
    minDateFimVigencia() {
      if (this.form.inicioVigencia === null) {
        return 'today';
      }
      return this.utils.add365Dias(this.form.inicioVigencia);
    },
    escolherCPFCNPJMask() {
      return this.form.cpfcnpj.length <= 14
        ? '###.###.###-##'
        : '##.###.###/####-##';
    },
    escolherCPFCNPJMin() {
      return this.form.cpfcnpj.length <= 14 ? 14 : 18;
    },
    arrayModelosEncontrados() {
      return this.mostrarMaisModelosEncontrados
        ? this.modelosFipeEncontrados
        : this.modelosFipeEncontradosReduzido;
    },
    errors() {
      return this.$validator.errors.all();
    },
  },
  watch: {
    isLanding() {
      this.validaIsLanding();
    },
    isCarroZero: function (newValue) {
      this.verificaZero(newValue);
    },
    dados() {
      this.preencheForm();
    },
    permitirRestricoes(value) {
      this.restricoesSelecionadas =
        value === false
          ? [{idRestricao: null, descricao: 'Nenhuma Restrição'}]
          : [];
    },
    'form.veiculo.resultFipe.preco': function (newValue) {
      const valorNf = this.form.valorNf;
      this.form.precoVeiculo =
        (!this.form.isZero && !valorNf) ||
        (this.form.isZero && !this.verificaEmpresa())
          ? newValue
          : valorNf;

      this.calcularCoberturaConjunto();
    },
    'form.valorNf': function (value) {
      this.form.precoVeiculo =
        this.form.isZero && this.verificaEmpresa()
          ? value
          : this.form.veiculo.resultFipe.preco;

      this.calcularCoberturaConjunto();
    },
    'idTipoFipe.id': function (newValue) {
      if (newValue === 3 && !this.permitirSomenteAgregado) {
        this.exibirValorTotalConjunto = true;
      }

      if (newValue !== 3) {
        this.exibirValorTotalConjunto = false;
        this.permitirCaminhao = false;
        this.form.caminhao = false;

        this.permitirImplemento = false;
        this.form.implemento = false;

        this.permitirAgregado = false;
        this.form.agregado = false;

        this.permitirSomenteAgregado = false;
        this.form.somenteAgregado = false;

        this.form.implementos = [];
        this.form.agregados = [];

        this.configuracaoPropostaCaminhao = false;
      }
      this.calcularCoberturaConjunto();
    },
    'form.precoVeiculo': function (value) {
      if (this.form.somenteAgregado === true) {
        this.form.valorTotalConjunto = value;
        this.form.valorCobertura = value;
      }
    },
    placaEncontrada: function (value) {
      if (value === false) this.resetBuscaPlaca();

      if (this.alterarGrupoVeiculoCotacao) {
        this.habilitaAlterarGrupo = value === false ? false : true;
      }
    },
    buscouRegionais() {
      if (!this.$can('Permitir alterar Corretora da proposta', 'Cotações')) {
        this.passo = 1;
        return;
      }
      if (this.isInterno != true) {
        this.passo = 1;
        return;
      }

      if (
        this.buscouRegionais &&
        this.regionais.length <= 1 &&
        this.buscouDivisoes &&
        this.divisoes.length <= 1
      ) {
        this.passo = 1;
        return;
      }
    },
    buscouDivisoes() {
      if (!this.$can('Permitir alterar Corretora da proposta', 'Cotações')) {
        this.passo = 1;
        return;
      }
      if (this.isInterno != true) {
        this.passo = 1;
        return;
      }
      if (
        this.buscouRegionais &&
        this.regionais.length <= 1 &&
        this.buscouDivisoes &&
        this.divisoes.length <= 1
      ) {
        this.passo = 1;
        return;
      }
    },
    passo() {
      if (this.passo === 1 && this.idCotacaoRapida) {
        this.buscaCotacaoRapida();
      }
      if (this.passo === 1 && this.idPreCotacao) {
        this.buscaPreCotacao();
      }
    },
    cilindradas: function (newValue) {
      this.form.veiculo.cilindradas = newValue;
    },
    codigoSituacaoPlaca() {
      if (this.codigoSituacaoPlaca == 0) {
        this.btnDisabled2 = false;
      }

      if (this.codigoSituacaoPlaca == 999) {
        this.btnDisabled2 = true;
      }
    },
    'form.inicioVigencia': function (value) {
      this.form.fimVigencia = this.utils.add365Dias(value);
    },
    listAgravos() {
      this.form.agravos = this.utils.atribuirAgravosForm(this.listAgravos);

      this.$refs.AgravosForm.atribuirAgravos();
    },
  },
  data() {
    const tiposPessoas = [
      {label: 'Selecione', id: null},
      {label: 'Pessoa Física', id: 'Pessoa Física'},
      {label: 'Pessoa Jurídica', id: 'Pessoa Jurídica'},
    ];
    return {
      TIPO_APOLICE: TIPO_APOLICE,
      generateQuotation: false,
      dadosProposta: {},
      thirdStep: false,
      total: 0,
      quotationData: {
        implement: 0,
        truck: false,
        implementOnly: 0,
        aggregateDescription: null,
        isNew: false,
        invoice: null,
        invoiceDate: null,
        invoiceValue: 0,
        allowsInvoiceSelfService: true,
        showVehicleValuesInProposal: true,
        prospect: {
          type: '',
          name: '',
          nomeSocial: false,
          nomeCivil: '',
          email: '',
          taxId: '',
          phone: null,
          cellphone: '',
          number: '',
          complement: '',
          state: '',
          city: '',
          address: '',
          neighborhood: '',
          zipCode: '',
          individualInvoice: true,
          hasntCnh: false,
        },
        vehicles: [],
        increases: [],
        charges: [],
      },
      idTipoApolice: 1,
      gruposAux: null,
      desabilitarInputVeiculoZero: false,
      propostaParaSomenteAgregado: false,
      hideLogo: this.$route.query.hideLogo,
      colorButton: this.$route.query.colorButton,
      showPanel: this.$route.query.showPanel,
      fixedButton: this.$route.query.fixedesabilitaAlterarMarcaButton,
      isRedirect: this.$route.query.isRedirect,
      nomeConsultorPlaca: '',
      modalPlacaRecusada: false,
      permitePlacaRepetida: null,
      idGrupoVinculoAgregado: null,
      tipoConfiguracaoCaminhao: null,
      gruposAgregados: [],
      msgValidacaoImplementoAgregado: '',
      validaImplementosAgregados: false,
      exibirformImplementoCompleto: false,
      exibirFormComplementoCompleto: false,
      exibirValorTotalConjunto: false,
      permitirRestricoes: null,
      alterarGrupoVeiculoCotacao: null,
      habilitaAlterarGrupo: false,
      desabilitaAlterarMarca: true,
      desabilitaAlterarAnoModelo: true,
      desabilitaAlterarModelo: true,
      desabilitaAlterarAnoFabricacao: true,
      resetFormComplemento: false,
      placaVinculoSelecionado: null,
      chassiVinculoSelecionado: null,
      placaVeiculoTratorSelecionado: null,
      chassiVeiculoTratorSelecionado: null,
      implementoSelecionado: {},
      agregadoSelecionado: {},
      configuracaoPropostaCaminhao: false,
      permitirImplemento: false,
      permitirCaminhao: false,
      permitirSomenteAgregado: false,
      permitirAgregado: false,
      modalImplemento: false,
      modalComplemento: false,
      isCarroZero: false,
      regionalDefault: [],
      regionaisUsuario: [],
      usuarios_regionais: [],
      modalForm: false,
      contFormDesconto: 0,
      openEscolherAssociado: false,
      logo: '',
      insideApp: false,
      isInterno: false,
      alteraRegional: false,
      formCompletoB2C: false,
      exibeItensObrigatoriosB2C: true,
      isPropostaConsultor: false,
      exibeCilindrada: false,
      percentage: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: ' %',
        precision: 1,
        maxLength: 6,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      passo: 0,
      dadosConsultor: null,
      decoded: null,
      aguardeCadastro: false,
      idEmpresa: this.idEmpresaProps
        ? this.idEmpresaProps
        : this.$route.params.idEmpresa,
      id_usuario: this.$route.params.idUsuario,
      idGrupo: {},
      idMarca: null,
      idModelo: null,
      idAnoModelo: null,
      idAnoFabricacao: null,
      idTipoFipe: null,
      estados: [],
      cidades: [],
      grupos: [],
      mostrarModalGrupos: false,
      tipos: [],
      produtos: [],
      produtosObrigatorios: [],
      produtosNaoObrigatorios: [],
      restricoesSelecionadas: [],
      formAssociadoEncontrado: {},
      associadoEncontrado: [],
      listaProdutosMensais: [],
      listaProdutosAAvista: [],
      produtoToDesconto: null,
      modalCreditCard: false,
      mostrarModalNovoValorProduto: false,
      novoValorProduto: {},
      listCartoes: [],
      itens: null,
      dadosFinanceiros: null,
      formasPagamentoEncontradas: false,
      marcas: [],
      modelos: [],
      modelosAux: [],
      anosModelo: [],
      anosFabricacao: [],
      restricoes: [],
      foraTabela: null,
      languages: lang,
      cep: null,
      endereco: null,
      bairro: null,
      estado: null,
      cidade: null,
      funcoesValicao: null,
      hasCartaoCredito: null,
      isCartaoAvista: null,
      isCartaoMensal: null,
      btnDisabled: null,
      dadosPlaca: null,
      placaEncontrada: false,
      mostrarMaisModelosEncontrados: false,
      modelosFipeEncontradosReduzido: [],
      modelosFipeEncontrados: [],
      titleSideBar: 'Desconto',
      modeloFipeSelecionado: null,
      modeloFipeAnoModeloSelecionado: null,
      idTipoModeloSelecionado: null,
      fipeEncontrada: false,
      radioSelecionado: null,
      btnDisabled2: false,
      regionais: [{text: null, label: 'Selecione'}],
      buscouRegionais: false,
      divisoes: [{text: null, label: 'Selecione'}],
      buscouDivisoes: false,
      idPreCotacao: null,
      usaUF: false,
      informacoes: [],
      cilindradas: null,
      dicionarioChassisNacionais: [],
      dicionarioTiposVeiculos: {},
      tiposPessoas,
      form: {
        origemCadastroProposta: window.location,
        caminhao: false,
        implemento: false,
        agregado: false,
        somenteAgregado: false,
        descricaoAgregado: null,
        implementos: [],
        agregados: [],
        valorTotalConjunto: 0, // é a Soma o preço do caminhão + implemento + agregado
        valorCobertura: 0,
        idEmpresa: this.idEmpresaProps
          ? this.idEmpresaProps
          : this.$route.params.idEmpresa,
        idGrupo: {},
        regional: null,
        idDivisao: null,
        nome: null,
        nomeSocial: null,
        nomeCivil: null,
        tipoPessoa: null,
        cpfcnpj: '',
        email: '',
        telefone: null,
        precoVeiculo: 0,
        numero: null,
        complemento: null,
        cidade: '',
        estado: null,
        endereco: null,
        bairro: null,
        cep: null,
        placa: '',
        isZero: false,
        idMarcaParticipacao: null,
        idModeloParticipacao: null,
        restricoesSelecionadas: [],
        produtosSelecionados: [],
        nf: null,
        dataNf: null,
        valorNf: 0,
        chassi: null,
        numeroMotor: null,
        renavam: null,
        combustivel: null,
        cor: null,
        quantidadePassageiro: null,
        valor: 0, //preço utilizado no simulador
        permiteInvoiceSelfService: true,
        exibirValoresVeiculoNaProposta: true,
        idTipoDesconto: '',
        dadosFinanceiros: {
          mensais: null,
          avista: null,
        },
        veiculo: {
          idGrupo: null,
          tipoVeiculo: null,
          codigoMarca: null,
          codigoModelo: null,
          anoGeral: null,
          anoModelo: null,
          anoFabricacao: null,
          codigoTipoCombustivel: null,
          combustivel: '',
          marca: null,
          modelo: null,
          codigoFipe: '',
          ano: null,
          resultFipe: {},
        },
        dadosUtm: [],
        placas: [],

        // seguradora
        tipoProposta: null,
        tipoContrato: null,
        inicioVigencia: null,
        fimVigencia: null,
        agravos: [],
        carregamentos: {},
      },
      consultorCelular: null,
      idTipoFipeAux: null,
      regionalConsultorPlaca: null,
      modalInfoDataSaidaNf: false,
      btnBlock: false,
      exibirIptDadosVeiculo: false,
      placaValidada: false,
      codigoSituacaoPlaca: '0',
      situacaoPlaca: '',
      buscouProdutos: false,
      clicks: 0,

      // seguradora
      configdateTimePickerDay: {
        minDate: 'today',
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
        disabled: true,
      },
      listTiposProposta: [],
      listTiposContrato: [],
      listAgravos: [],
      listAgravosPorGrupo: [],
      listCarregamentos: [],
      recalcularValorProdutos: false,

      // funções uteis da Nova Cotação da Segurada agrupadas para um futura V2
      utils: NCSv2_utils,
    };
  },
  methods: {
    saveProductsRcvat(quotation) {
      this.quotationData.vehicles = quotation.vehicles;
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Produtos adicionados com sucesso',
        color: 'success',
      });
    },
    defineTipoPagamentoProdutos(objPagamento, isMensal) {
      if (isMensal) {
        this.form.dadosFinanceiros.mensais = objPagamento.valor;
      }

      if (!isMensal) {
        this.form.dadosFinanceiros.avista = objPagamento.valor;
      }

      this.form.produtosSelecionados.forEach((item) => {
        if (item.ismensal && this.form.dadosFinanceiros.mensais) {
          item.idTipoPagamentoEmpresa =
            this.form.dadosFinanceiros.mensais.idTipoPagamentoEmpresa;
          item.tipoPagamento = this.form.dadosFinanceiros.mensais.tipoPagamento;

          return;
        }

        if (!item.ismensal && this.form.dadosFinanceiros.avista) {
          item.idTipoPagamentoEmpresa =
            this.form.dadosFinanceiros.avista.idTipoPagamentoEmpresa;
          item.tipoPagamento = this.form.dadosFinanceiros.avista.tipoPagamento;

          return;
        }
      });

      if (this.form.agregado) {
        this.form.agregados.forEach((item) => {
          item.produtosSelecionados.forEach((produto) => {
            if (produto.ismensal && this.form.dadosFinanceiros.mensais) {
              produto.idTipoPagamentoEmpresa =
                this.fform.dadosFinanceiros.mensais.idTipoPagamentoEmpresa;
              produto.tipoPagamento =
                this.form.dadosFinanceiros.mensais.tipoPagamento;

              return;
            }

            if (!produto.ismensal && this.form.dadosFinanceiros.avista) {
              produto.idTipoPagamentoEmpresa =
                this.form.dadosFinanceiros.avista.idTipoPagamentoEmpresa;
              produto.tipoPagamento =
                this.form.dadosFinanceiros.avista.tipoPagamento;

              return;
            }
          });
        });
      }
    },
    getWindow() {
      return window.location.origin;
    },
    definirTituloListaComplementos(item) {
      const temPlaca = item.placa ? item.placa + ' ' : '';
      const temChassi = item.chassi ? item.chassi + ' ' : '';
      const temDescricao = item.descricao ? item.descricao + ' -' : '';
      const temValorCobertura = item.valorCobertura ? item.valorCobertura : '';
      const temValorNf = item.valorNf ? item.valorNf : '';
      const temValor = ` Valor: R$ ${temValorCobertura || temValorNf}`;

      return `${temPlaca || temChassi}${temDescricao}${temValor}`;
    },
    definirSubTituloListaComplementos(item) {
      const temMarca = item.marca ? item.marca + ' ' : '';
      const temModelo = item.modelo ? item.modelo + ' ' : '';
      const temPlacaVinculo = item.placaVinculo
        ? `| Vinculo: ${item.placaVinculo}`
        : '';
      const temChassiVinculo = item.chassiVinculo
        ? `| Vinculo: ${item.chassiVinculo}`
        : '';
      const temVinculo = temPlacaVinculo || temChassiVinculo;

      return `${temMarca}${temModelo}${temVinculo}`;
    },
    exibirPlaca() {
      const exibirPlaca = this.isCarroZero || this.form.somenteAgregado;
      return !exibirPlaca;
    },
    calcularCoberturaConjunto() {
      const temPrecoFipe = this.form.veiculo.resultFipe.preco;

      const precoFIPE = temPrecoFipe
        ? parseFloat(
          this.form.veiculo.resultFipe.preco
            .replace('R$ ', '')
            .replace('.', ''),
        )
        : 0;

      const temValorNf = this.form.valorNf;
      const valorNF =
        temValorNf && typeof this.form.valorNf == 'string'
          ? parseFloat(
            this.form.valorNf
              .replace('R$ ', '')
              .replace('.', '')
              .replace(',', '.'),
          )
          : 0;
      const veiculoZero = this.form.isZero;
      let preco = veiculoZero ? valorNF : precoFIPE;

      if (veiculoZero && this.verificaEmpresa()) {
        preco = precoFIPE;
        this.form.valorNf = precoFIPE;
      }

      let totalValorImplemento = 0;
      let valorTotalConjunto = 0;

      this.form.implementos.forEach((implemento) => {
        const {valorCobertura, valorNf} = implemento;
        totalValorImplemento += valorNf > 0 ? valorNf : valorCobertura;
      });

      valorTotalConjunto = preco + totalValorImplemento;

      this.form.valorTotalConjunto = valorTotalConjunto;
      this.form.valorCobertura = valorTotalConjunto || precoFIPE;
    },
    AtualizarComplemento(dadosComplemento) {
      const {index, ...dadosComplementos} = dadosComplemento;
      const tipo = `${dadosComplementos.tipo}s`;
      const itemSelecionado = `${dadosComplementos.tipo}Selecionado`;

      this.form[tipo][index] = dadosComplementos;
      this.modalComplemento = false;
      this[itemSelecionado] = {};

      this.calcularCoberturaConjunto();
    },
    excluirComplemento(dadosComplemento) {
      const {index, ...dadosComplementos} = dadosComplemento;
      const tipo = `${dadosComplementos.tipo}s`;
      const itemSelecionado = `${dadosComplementos.tipo}Selecionado`;

      this.form[tipo].splice(index, 1);
      this[itemSelecionado] = {};

      this.calcularCoberturaConjunto();
    },
    editarComplemento(dadosComplemento) {
      this.agregadoSelecionado = dadosComplemento;
      this.resetFormComplemento = false;
      this.abrirModalComplemento();
    },
    adicionarComplemento(dadosComplementos) {
      const tipo = `${dadosComplementos.tipo}s`;
      this.form[tipo].push(dadosComplementos);

      this.modalComplemento = false;

      if (dadosComplementos.tipo === 'agregado')
        this.validaImplementosAgregados = false;

      if (dadosComplementos.tipo === 'implemento') {
        this.validaImplementosAgregados = false;
        this.calcularCoberturaConjunto();
      }

      this.msgValidacaoImplementoAgregado = '';
    },
    verificaZero(value) {
      this.form.isZero = value;

      //if (value) {
      this.form.placa = null;
      this.resetBuscaPlaca();
      // }

      if (this.alterarGrupoVeiculoCotacao) {
        this.habilitaAlterarGrupo = this.form.isZero ? false : true;
      }
    },
    keymonitorPlaca: async function () {
      this.btnDisabled2 = false;
      if (this.form.placa.length == 8) {
        this.placaValidada = await this.consultarExisteCotacao();

        await this.consultarPlacaChassiBaseBP('placa');
        if (!this.placaValidada) {
          return;
        }

        this.buscaPlacaFipe();
      }
    },
    keymonitor: function () {
      if (this.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            this.endereco = res.data.street;
            this.bairro = res.data.neighborhood;
            this.cidade = res.data.city;
            this.estado = res.data.state;
            this.form.estado = this.estado;
            this.form.cidade = this.cidade;
            this.form.endereco = this.endereco;
            this.form.bairro = this.bairro;
            this.form.cep = this.cep;

            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    setDesconto(item) {
      var aux = this.produtos.find((x) => x.id_produto == item.id_produto);
      //aux.descontoConcedido = item.valorDesconto;
      if (item.valorDesconto == 0) {
        aux.valorFinal = item.valor;
        aux.style = null;
      } else {
        // aux.valorFinal =  item.valor - (item.valor * item.valorDesconto) / 100;
        //  = item.valor - (item.valor * item.valorDesconto) / 100;
        aux.style = 'text-decoration: line-through;';
      }
      aux.isDesconto = false;

      this.produtos.forEach((element) => {
        if (element.id == item.id_produto) {
          element.valorFinal = aux.valorFinal;
          element.descontoConcedido = aux.descontoConcedido;
        }
      });
      this.produtoToDesconto = null;
    },
    onSubmit() {
      if (this.form.idDivisao) {
        this.passo = 1;
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione uma Regional',
          color: 'danger',
          timer: 5000,
        });
      }
    },
    voltar() {
      this.btnBlock = false;
      this.produtos = [];
      this.buscouProdutos = false;
      this.thirdStep = false;
    },
    buscaPlacaFipe() {
      if (this.form.placa.length === 8)
        return new Promise(async (resolve, reject) => {
          this.$vs.loading();

          service
            .post('CotacaoAberta', `BuscaDadosPlaca`, this.form)
            .then((res) => {
              this.dadosPlaca = {};
              if (res.status == 204 && res.data == '') {
                this.buscarPlacasZerado();
              }
              if (res.data) {
                this.dadosPlaca = res.data;
                this.preencheDadosPlaca();
              } else {
                this.placaEncontrada = false;
                this.exibirIptDadosVeiculo = true;
                this.dadosPlaca = {};
                this.habilitaAlterarGrupo = false;
              }
              this.$vs.loading.close();
              resolve();
            })
            .catch(() => {
              this.placaEncontrada = false;
              this.exibirIptDadosVeiculo = true;
              this.habilitaAlterarGrupo = false;
              this.modelosFipeEncontrados = [];
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Não foi possível buscar a placa, preencha os dados manualmente, ou tente novamente.',
                color: 'danger',
                timer: 10000,
              });

              reject();
            });
        });
    },
    resetBuscaPlaca(infoResetPlaca = null) {
      this.form.resultadoPlaca = null;
      this.form.chassi = null;
      this.form.renavam = null;
      this.form.combustivel = null;
      this.form.cor = null;
      this.form.quantidadePassageiro = null;
      this.placaEncontrada = false;
      this.btnDisabled = false;
      this.form.dataNf = null;
      this.form.valorNf = null;
      this.form.chassi = null;
      this.dadosPlaca = {};
      this.modelosFipeEncontrados = [];
      this.form.veiculo.resultFipe = {};
      this.form.valorTotalConjunto = 0;
      this.form.valorCobertura = 0;
      this.idGrupo = {};
      this.idTipoFipe = {};
      this.habilitaAlterarGrupo = false;
      //this.formCompletoB2C = true;
      this.form.veiculo.anoModelo = null;
      this.form.veiculo.combustivel = null;
      this.form.veiculo.tipoVeiculo = null;
      this.form.veiculo.idGrupo = null;
      this.form.precoVeiculo = 0;
      this.form.cilindradas = null;
      this.form.veiculo.cilindradas = null;
      this.exibeCilindrada = false;
      this.grupos = null;

      if (infoResetPlaca != null) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: infoResetPlaca,
          color: 'warning',
        });
      }

      this.calcularCoberturaConjunto();
    },
    exibePorcentagemDesconto(modelosFipeEncontrados) {
      this.modalForm = true;

      this.contFormDesconto = this.contFormDesconto + 1;
      if (this.modalForm == true) {
        this.itens = modelosFipeEncontrados;
        this.itens.estado = this.form.estado;
        this.itens.tipoProposta = this.form.tipoProposta;
      }
    },
    salvarDesconto(data) {
      this.setDesconto(data);
      this.form.idTipoDesconto = data.idTipoDesconto;
      this.modalForm = false;
    },
    preencheDadosPlaca() {
      const temDadosPlaca = !functions.isObjectEmpty(this.dadosPlaca);

      if (temDadosPlaca) {
        const temDadosExtraPlaca = !functions.isObjectEmpty(
          this.dadosPlaca.extra,
        );

        const temDadosFipePlaca = !functions.isObjectEmpty(
          this.dadosPlaca.fipe,
        );

        // Verificação realizada pois a mensagem de erro retornada é inconsistente
        const _dadosPlacaValidos =
          this.dadosPlaca.mensagemRetorno == 'Sem erros.' ||
          (temDadosExtraPlaca && temDadosFipePlaca);

        if (!_dadosPlacaValidos) {
          const menssagemParaResetPlaca =
            'Nenhum modelo foi associado a essa placa';

          this.resetBuscaPlaca(menssagemParaResetPlaca);
          this.placaEncontrada = false;
          this.exibirIptDadosVeiculo = true;
        } else {
          if (temDadosExtraPlaca) {
            this.form.resultadoPlaca = this.dadosPlaca;
            this.form.chassi = this.dadosPlaca.extra.chassi.toUpperCase();
            this.form.renavam = this.dadosPlaca.extra.renavam;
            this.form.numeroMotor = this.dadosPlaca.extra.motor;
            this.form.combustivel = this.dadosPlaca.extra.combustivel;
            this.form.cor = this.dadosPlaca.cor;
            this.form.quantidadePassageiro =
              this.dadosPlaca.extra.quantidade_passageiro;

            if (this.dadosPlaca.extra.tipo_veiculo) {
              var idTipoFipe = this.pegarTipoVeiculo(
                this.dadosPlaca.extra.tipo_veiculo,
              );
              var aux = this.tipos.find((x) => x.id == idTipoFipe);
              this.idTipoFipe = aux;
              if (idTipoFipe === 2) {
                this.exibeCilindrada = true;
                this.cilindradas = this.dadosPlaca.extra.cilindradas;
              } else {
                this.exibeCilindrada = false;
                this.cilindradas = null;
              }

              this.selecionaTipoFipe();
            }
          } else {
            this.cilindradas = null;
          }
          if (temDadosFipePlaca) {
            this.btnDisabled2 = true;
            this.placaEncontrada = true;
            this.exibirIptDadosVeiculo = false;
            this.formCompletoB2C = false;
            this.modelosFipeEncontrados = [];
            this.dadosPlaca.fipe.dados.forEach((element) => {
              element.selecionado = false;
              element.checked = null;
              this.modelosFipeEncontrados.push(element);
            });
            this.modelosFipeEncontrados.sort(function (a, b) {
              return a.score > b.score ? -1 : a.score < b.score ? 1 : 0;
            });
            this.scrollBloco('ModelosEncontrados');

            // SEGURADORA
            this.modelosFipeEncontradosReduzido = [];
            this.modelosFipeEncontradosReduzido = [
              {...this.modelosFipeEncontrados[0]},
            ];
            this.radioSelecionado = this.modelosFipeEncontrados[0].codigo_fipe;
            this.selecionaModelo(this.modelosFipeEncontrados[0]);
          }
        }
      }
    },
    scrollBloco(divDestino) {
      if (!this.isInterno) {
        setTimeout(() => {
          const element = this.$refs[divDestino];
          element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }, 500);
      }
    },
    pegarTipoVeiculo(tipo_veiculo) {
      const tipoVeiculo = this.dicionarioTiposVeiculos[tipo_veiculo];
      return tipoVeiculo ? tipoVeiculo.codigoTipo : 3;
    },
    async selecionaModelo(item) {
      for (let index = 0; index < this.modelosFipeEncontrados.length; index++) {
        const element = this.modelosFipeEncontrados[index];

        element.selecionado = null;

        if (element.codigo_fipe == item.codigo_fipe) {
          this.modeloFipeSelecionado = element.codigo_fipe;
          this.modeloFipeAnoModeloSelecionado = `${element.ano_modelo}-${element.tipo_modelo}`;
          this.idTipoModeloSelecionado = element.tipo_modelo;

          element.selecionado = true;
        }
      }

      // armazena o objeto do grupo selecionado
      const grupoVeiculoAux = this.idGrupo;

      // busca fipe do modelo
      await this.confirmaModeloFipe();

      if (!this.alterarGrupoVeiculoCotacao) {
        this.idGrupo = grupoVeiculoAux;
      }
      this.abrirModalGrupos();

      this.calcularCoberturaConjunto();

      this.anosFabricacao.unshift({text: 'Selecione', value: null});
    },
    buscarDicionarioTiposVeiculos() {
      service
        .post('dicionarios', 'buscar-dicionario-tipos-veiculos', {})
        .then((res) => {
          this.dicionarioTiposVeiculos = res.data;
        })
        .catch((e) => {
        });
    },
    buscarDicionarioChassisNacionais() {
      service
        .post('dicionarios', 'buscar-dicionario-chassis-nacionais', {})
        .then((res) => {
          this.dicionarioChassisNacionais = res.data;
        })
        .catch((e) => {
        });
    },
    verificaVeiculoImportado() {
      if (this.dadosPlaca && this.dadosPlaca.extra) {
        const chassi = this.dadosPlaca.extra.chassi.slice(0, 2);
        return !this.dicionarioChassisNacionais.includes(chassi.toUpperCase());
      } else {
        return false;
      }
    },
    separaGruposImportados(grupos = this.grupos) {
      const importado = this.verificaVeiculoImportado();
      const gruposImportados = grupos.filter(
        (grupo) => grupo.importado === importado,
      );
      this.grupos = gruposImportados.length ? gruposImportados : grupos;
    },
    async marcaGrupoPorModelo() {
      if (this.alterarGrupoVeiculoCotacao) {
        const idMarca = this.form.veiculo.codigoMarca;
        const idModelo = this.form.veiculo.codigoModelo;

        if (!idMarca || !idModelo) {
          this.$vs.loading().close();

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível buscar os grupos, sistema temporariamente indisponivel ou falha de conexão com a internet ',
            color: 'warning',
            timer: 5000,
          });

          return;
        }

        const tipo = this.form.veiculo.tipoVeiculo || this.idTipoFipe.id;
        const anoFabricacao = this.form.veiculo.anoFabricacao;
        const anoModelo = this.form.veiculo.anoModelo;
        //const _idEmpresa = localStorage.getItem('idEmpresa');
        const _idEmpresa = !this.$route.params.idEmpresa
          ? this.form.idEmpresa
          : this.$route.params.idEmpresa;

        const objBuscaGrupo = {
          idEmpresa: _idEmpresa,
          idMarca,
          idModelo,
          tipo,
          anoFabricacao,
          anoModelo,
          importado: this.verificaEmpresa()
            ? this.verificaVeiculoImportado()
            : null,
        };

        const objGrupos = await service.post(
          'CotacaoAberta',
          'buscaGrupoMarcaModelo',
          objBuscaGrupo,
        );
        this.preencheGruposPosSelecao(objGrupos);
      }
    },
    async confirmaModeloFipe() {
      var modelo = this.modelosFipeEncontrados.find(
        (x) => x.codigo_fipe == this.modeloFipeSelecionado,
      );

      if (!this.form.idTipoFipe) {
        var aux = this.tipos.find((x) => x.id == modelo.tipo_modelo);
        this.form.idTipoFipe = aux;
        this.idTipoFipe = aux;
        await this.selecionaTipoFipe();
      }

      this.$vs.loading();
      modelo.codigoTipoVeiculo = modelo.tipo_modelo;
      modelo.anoModelo = this.dadosPlaca.anoModelo;
      modelo.selecionado = true;

      await service
        .post('CotacaoAberta', 'BuscaDadosFipeModelo', modelo)
        .then(async (res) => {
          let dadosModelo = null;
          if (this.alterarGrupoVeiculoCotacao) {
            let idMarca = res.data.id_marca;
            let idModelo = res.data.id_modelo;

            if (!idMarca || !idModelo) {
              const modelo = res.data.find(
                (_modelo) =>
                  _modelo.fipe_codigo == this.modeloFipeSelecionado &&
                  _modelo.id_modelo_ano == this.modeloFipeAnoModeloSelecionado,
              );

              dadosModelo = modelo;
              idMarca = modelo.id_marca;
              idModelo = modelo.id_modelo;

              if (!idMarca || !idModelo) {
                this.$vs.loading().close();

                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: 'Não foi possível busca dados, sistema indisponivel no momento ou falha com a conexão de internet ',
                  color: 'warning',
                  timer: 8000,
                });

                return;
              }
            }

            const tipo =
              res.data.tipo || dadosModelo.tipo || this.idTipoModeloSelecionado;
            const anoFabricacao = res.data.ano;
            const anoModelo = res.data.ano_modelo;
            const _idEmpresa = !this.$route.params.idEmpresa
              ? this.form.idEmpresa
              : this.$route.params.idEmpresa;

            const objBuscaGrupo = {
              idEmpresa: _idEmpresa,
              idMarca,
              idModelo,
              tipo,
              anoFabricacao,
              anoModelo,
              importado: this.verificaEmpresa()
                ? this.verificaVeiculoImportado()
                : null,
            };

            const objGrupos = await service.post(
              'CotacaoAberta',
              'buscaGrupoMarcaModelo',
              objBuscaGrupo,
            );

            this.preencheGruposPosSelecao(objGrupos);
            if (objGrupos.data.length === 0) {
              this.verificaEmpresa() && this.separaGruposImportados();
              this.habilitaAlterarGrupo = false;

              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Nenhum grupo encontrado, selecione um grupo de Veículo',
                color: 'danger',
                timer: 5000,
              });
            }

            if (objGrupos.data.length > 0) {
              this.idGrupo = objGrupos.data[0];
              this.grupos = objGrupos.data;

              this.exibeCilindrada =
                this.idGrupo.idTipoFipe === 2 ? true : false;

              // if (this.idGrupo.idTipoFipe === 3) {
              this.permitirCaminhao = true;
              this.permitirAgregado = this.idGrupo.permiteAgregado
                ? true
                : false;
              this.permitirImplemento = this.idGrupo.permiteImplemento
                ? true
                : false;

              this.permitirSomenteAgregado = this.idGrupo.permiteSomenteAgregado
                ? true
                : false;

              this.form.somenteAgregado = this.permitirSomenteAgregado
                ? true
                : false;

              this.configuracaoPropostaCaminhao =
                this.idGrupo.permiteAgregado || this.idGrupo.permiteImplemento
                  ? true
                  : false;
              // }

              this.habilitaAlterarGrupo = true;
            }

            if (objGrupos.data.length > 1) {
              this.habilitaAlterarGrupo = false;
              this.verificaEmpresa() &&
              this.separaGruposImportados(objGrupos.data);
            }
          }

          this.form.veiculo.resultFipe = !dadosModelo ? res.data : dadosModelo;
          this.form.veiculo.anoModelo = this.dadosPlaca.anoModelo
            ? parseInt(this.dadosPlaca.anoModelo)
            : null;
          this.form.veiculo.anoFabricacao = this.dadosPlaca.ano
            ? parseInt(this.dadosPlaca.ano)
            : null;
          this.form.veiculo.combustivel = !dadosModelo
            ? res.data.combustivel
            : dadosModelo.combustivel;
          this.fipeEncontrada = true;

          this.$vs.loading.close();
          this.btnDisabled2 = false;
          this.$forceUpdate();
        });
    },
    preencheGruposPosSelecao(objGrupos) {
      if (objGrupos.data.length === 0) {
        this.habilitaAlterarGrupo = true;
      }

      if (objGrupos.data.length > 0) {
        if (this.idGrupo) {
          let grupoExistente = objGrupos.data.find(
            (x) => x.id == this.idGrupo.id,
          );
          if (!grupoExistente) {
            this.idGrupo = objGrupos.data[0];
          }
        } else {
          this.idGrupo = objGrupos.data[0];
        }

        this.grupos = objGrupos.data;

        this.exibeCilindrada = this.idGrupo.idTipoFipe === 2 ? true : false;

        // if (this.idGrupo.idTipoFipe === 3) {
        this.permitirCaminhao = true;
        this.permitirAgregado = this.idGrupo.permiteAgregado ? true : false;

        this.permitirImplemento = this.idGrupo.permiteImplemento ? true : false;

        this.permitirSomenteAgregado = this.idGrupo.permiteSomenteAgregado
          ? true
          : false;

        this.form.somenteAgregado = this.permitirSomenteAgregado ? true : false;

        this.configuracaoPropostaCaminhao =
          this.idGrupo.permiteAgregado || this.idGrupo.permiteImplemento
            ? true
            : false;
        //}
        this.habilitaAlterarGrupo = false;
      }

      if (objGrupos.data.length > 1) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Mais de Um grupo encontrado, selecione um grupo de Veículo',
          color: 'warning',
          timer: 5000,
        });
        this.abrirModalGrupos();
        this.habilitaAlterarGrupo = true;
      }
    },
    buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            if (element[campoPK] == this.decoded.id_regional) {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            }
          });
        });
    },
    voltarPasso() {
      this.passo = 0;
    },
    buscaEmail() {
      if (this.form.email.length > 4)
        return new Promise(async (resolve, reject) => {
          this.$vs.loading();
          service
            .post('CotacaoAberta', `validaAssociado`, this.form)
            .then((res) => {
              if (res.data.length > 0) {
                this.associadoEncontrado = res.data;
                this.openEscolherAssociado = true;
              } else {
                this.form.idProspect = null;
              }

              this.$vs.loading.close();
              resolve();
            })
            .catch((e) => {
              this.$vs.loading.close();
              reject(e);
            });
        });
    },
    adicionarCartaoLista(value) {
      this.listCartoes.forEach((element) => {
        element.selecionado = false;
      });

      this.modalCreditCard = false;
      this.listCartoes.push(value);

      this.btnDisabled = false;
    },
    selecionaCartao(item) {
      this.listCartoes.forEach((element) => {
        element.selecionado = false;
      });
      item.selecionado = true;
      this.$vs.loading();
      service
        .post('Associado', 'AtualizarCartaoAssociadoPrincipal', {
          idProspect: this.form.idProspect,
          idAssociadoCartao: item.id_associado_cartao,
        })
        .then(() => {
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    filtraCartoesSelecionados() {
      return this.listCartoes.filter((x) => x.selecionado == true);
    },
    verificaCartaoCredito() {
      this.hasCartaoCredito = false;
      this.btnDisabled = false;

      this.listaProdutosMensais.forEach((element) => {
        if (element.valor)
          if (element.valor.tipoPagamento == 'Cartão de Crédito') {
            this.hasCartaoCredito = true;
            this.isCartaoMensal = true;
            this.btnDisabled = true;
            if (this.filtraCartoesSelecionados().length > 0)
              this.btnDisabled = false;
          }
      });
      this.listaProdutosAAvista.forEach((element) => {
        if (element.valor)
          if (element.valor.tipoPagamento == 'Cartão de Crédito') {
            this.hasCartaoCredito = true;
            this.isCartaoAvista = true;
            this.btnDisabled = true;
            if (this.filtraCartoesSelecionados().length > 0)
              this.btnDisabled = false;
          }
      });
    },
    buscaDadosRegionais() {
      this.$vs.loading();
      this.regionais = [];
      let objSend = {};
      objSend.idEmpresa = !this.$route.params.idEmpresa
        ? this.form.idEmpresa
        : this.$route.params.idEmpresa;
      service
        .post('Usuario', 'find/' + this.id_usuario, objSend)
        .then((res) => {
          this.$vs.loading.close();
          this.id_usuario = res.data[0].idUsuario;
          res.data.forEach((element) => {
            if (element.Usuarios_Regional) {
              var usuarios_regionais = element.Usuarios_Regional;
              this.regionais.push({
                id: usuarios_regionais.idRegional,
                label: usuarios_regionais.nome,
              });

              this.form.regional = {
                id: usuarios_regionais.idRegional,
                label: usuarios_regionais.nome,
              };

              this.form.idDivisao = element.idDivisao;

              this.buscaDivisoes();
            }

            if (element.usuarios_regionais.length > 0) {
              this.usuarios_regionais = element.usuarios_regionais;

              this.usuarios_regionais.forEach((elementSel) => {
                this.regionais.push({
                  id: elementSel.id_regional,
                  label: elementSel.nome,
                });
              });
            }

            this.idRegionais = this.regionais.map((item) => item.id);
            this.buscouRegionais = true;

            //this.buscouRegionais();
          });
        });
    },
    buscaFormasPagamento() {
      this.$vs.loading();
      service
        .post('CotacaoAberta', 'buscaFormasPagamentoSemProposta', {
          idEmpresa: this.form.idEmpresa,
          idProspect: this.form.idProspect,
          produtos: this.form.produtosSelecionados,
        })
        .then((res) => {
          this.formasPagamentoEncontradas = true;
          this.listCartoes = res.data.cartoes;
          var formas = res.data.formasPagamento;
          var aux = [];

          for (let index = 0; index < formas.length; index++) {
            const element = formas[index];
            var valor = null;

            if (this.dadosFinanceiros)
              if (element.isMensal) {
                var findValor = this.dadosFinanceiros.mensais.find(
                  (x) => x.nomeProduto == element.nomeProduto,
                );
                valor = findValor.valor;
              } else {
                let findValor = this.dadosFinanceiros.avista.find(
                  (x) => x.nomeProduto == element.nomeProduto,
                );
                valor = findValor.valor;
              }

            if (index == 0) {
              aux.push({
                idProduto: element.idProduto,
                nomeProduto: element.nomeProduto,
                isMensal: element.isMensal,
                valor: valor,
                formas: [
                  {
                    value: {
                      idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
                      tipoPagamento: element.nomePagamento,
                    },
                    text: element.nomePagamento,
                  },
                ],
              });
            } else {
              if (element.nomeProduto == formas[index - 1].nomeProduto) {
                var aux2 = aux.find(
                  (x) => x.nomeProduto == element.nomeProduto,
                );
                aux2.formas.push({
                  value: {
                    idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
                    tipoPagamento: element.nomePagamento,
                  },
                  text: element.nomePagamento,
                });
              } else {
                aux.push({
                  idProduto: element.idProduto,
                  nomeProduto: element.nomeProduto,
                  isMensal: element.isMensal,
                  valor: valor,
                  formas: [
                    {
                      value: {
                        idTipoPagamentoEmpresa: element.id_tipoPagamentoEmpresa,
                        tipoPagamento: element.nomePagamento,
                      },
                      text: element.nomePagamento,
                    },
                  ],
                });
              }
            }
          }

          if (!this.form.idProspect) {
            for (let index = 0; index < aux.length; index++) {
              var element = aux[index];
              if (!element.isMensal) {
                element.formas = element.formas.filter(
                  (x) => x.text != 'Cartão de Crédito',
                );
              }
            }
          }

          this.listaProdutosMensais = [];
          this.listaProdutosAAvista = [];
          aux.forEach((element) => {
            element.formas.unshift({value: null, text: 'Selecione'});
            if (element.isMensal) this.listaProdutosMensais.push(element);
            else this.listaProdutosAAvista.push(element);
          });
          this.verificaCartaoCredito();
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível encontrar as formas de Pagamento',
            color: 'danger',
          });
        });
    },
    selecionaPorEmail(item) {
      this.form.tipoProposta = 'Adesão';
      this.form.tipoPessoa = item.tipo;
      this.form.nome = item.nome;
      this.form.nomeSocial = item.nomeSocial;
      this.form.nomeCivil = item.nomeCivil;
      this.form.telefone = item.telefone;
      this.form.celular = item.celular;
      this.cep = item.cep;
      this.form.cep = item.cep;
      this.form.endereco = item.endereco;
      this.form.bairro = item.bairro;
      this.form.cidade = item.cidade;
      this.form.estado = item.estado;

      this.estado = this.estados.find((estado) => estado.label === item.estado);
      this.cidade = item.cidade;

      this.form.pais = item.pais;
      this.form.preenchidoAutomatico = true;
      this.form.idProspect = item.idProspect;
      this.openEscolherAssociado = false;
    },
    selecionaEstado() {
      if (!this.estado) {
        this.cidade = null;
        return;
      }

      const aux = this.estados.find((x) => x.id == this.estado.id);
      this.form.estado = aux.label;
    },
    selecionaCidade() {
      if (!this.cidade) {
        this.cidade = null;
        return;
      }

      var aux = this.cidades.find((x) => x.id == this.cidade.id);
      this.form.cidade = aux.label;
    },
    selecionaRestricoes() {
      this.form.restricoesSelecionadas = [];
      this.restricoesSelecionadas.forEach((element) => {
        this.form.restricoesSelecionadas.push(element.idRestricao);
      });
    },
    somaValorTotalMesAtualizados() {
      var total = 0;

      this.form.produtosSelecionados.forEach((prod) => {
        if (prod.ismensal == true) total = total + prod.valorFinal;
      });

      return total;
    },
    somaValorTotalMesAtualizadosAgregado(id) {
      let total = 0;
      this.form.agregados[id].produtosSelecionados.forEach((prod) => {
        if (prod.ismensal == true) total = total + prod.valorFinal;
      });
      return total;
    },
    somaValorTotalAtualizados() {
      var total = 0;
      this.form.produtosSelecionados.forEach((prod) => {
        if (prod.ismensal != true) total = total + prod.valorFinal;
      });

      return total;
    },
    somaValorTotalAtualizadosAgregado(id) {
      let total = 0;
      this.form.agregados[id].produtosSelecionados.forEach((prod) => {
        if (prod.ismensal != true) total = total + prod.valorFinal;
      });
      return total;
    },
    formataMoeda(valor) {
      return `R$ ${valor.toFixed(2)} `;
    },
    somaValorTotalMes() {
      var total = 0;
      this.produtos.forEach((prod) => {
        if (prod.obrigatorio == true)
          if (prod.ismensal == true) total = total + prod.valor;
      });
      return total;
    },
    somaValorTotal() {
      var total = 0;
      this.produtos.forEach((prod) => {
        if (prod.obrigatorio == true)
          if (prod.ismensal != true) total = total + prod.valor;
      });
      return total;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    validateStyle(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return {
          border: '1px solid red !important',
          borderRadius: '5px',
        };
      }
      return null;
    },
    selecionaTipo() {
      if (this.placaEncontrada) {
        const _tipoVeiculo = this.tipos.find(
          (tipo) => tipo.id == this.idGrupo.idTipoFipe,
        );
        this.idTipoFipe = _tipoVeiculo;

        const verificaTipoSelecionado = this.modelosFipeEncontrados.find(
          (modelo) => modelo.codigo_fipe == this.modeloFipeSelecionado,
        );
        const tipoVeiculoCorreto =
          verificaTipoSelecionado.tipo_modelo == this.idTipoFipe.id;

        if (verificaTipoSelecionado && !tipoVeiculoCorreto) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'O tipo de veículo não é compatível com o tipo do grupo selecionado',
            color: 'warning',
          });

          this.resetBuscaPlaca();
        }

        this.idGrupo
          ? (this.form.veiculo.idGrupo = this.idGrupo.id)
          : (this.form.veiculo.idGrupo = null);
        this.idMarca = null;
        this.idModelo = null;
        this.idAnoModelo = null;
        this.idAnoFabricacao = null;
        this.modelos = [];
        this.anosModelo = [];
        this.anosFabricacao = [];

        this.idGrupo
          ? (this.form.veiculo.tipoVeiculo = this.idGrupo.idTipoFipe)
          : (this.form.veiculo.tipoVeiculo = null);

        if (this.idGrupo && this.idGrupo.idTipoFipe == 2) {
          this.exibeCilindrada = true;
        } else {
          this.exibeCilindrada = false;
        }

        if (this.idGrupo) {
          const grupoSelecionado = this.idGrupo;
          this.configuracaoPropostaCaminhao =
            grupoSelecionado.permiteAgregado ||
            grupoSelecionado.permiteImplemento
              ? true
              : false;

          this.permitirCaminhao =
            grupoSelecionado.idTipoFipe === 3 ? true : false;
          this.permitirImplemento = grupoSelecionado.permiteImplemento;
          this.permitirAgregado = grupoSelecionado.permiteAgregado;
          this.permitirSomenteAgregado =
            grupoSelecionado.permiteSomenteAgregado;
        }

        if (this.permitirSomenteAgregado) {
          this.form.somenteAgregado = true;
        }
      }
    },
    preencheMarca() {
      if (this.placaEncontrada) {
        if (this.idGrupo == null) {
          this.desabilitaAlterarMarca = true;
          this.desabilitaAlterarAnoModelo = true;
          this.desabilitaAlterarModelo = true;
          this.desabilitaAlterarAnoFabricacao = true;
        } else {
          this.desabilitaAlterarMarca = false;
        }

        var obj = {idGrupo: {}};
        obj.idGrupo.id = this.form.veiculo.idGrupo;
        obj.idEmpresa = !this.$route.params.idEmpresa
          ? this.form.idEmpresa
          : this.$route.params.idEmpresa;
        this.form.veiculo.marca = null;
        this.form.veiculo.modelo = null;
        this.form.veiculo.anoGeral = null;
        this.form.veiculo.anoFabricacao = null;
        this.form.cilindradas = null;
        this.idMarca = null;
        this.marcas = [];
        this.modelos = [];
        this.anosModelo = [];
        this.anosFabricacao = [];
        this.$vs.loading();
        this.desabilitaAlterarAnoModelo = true;
        this.desabilitaAlterarModelo = true;
        this.desabilitaAlterarAnoFabricacao = true;
        service
          .post('CotacaoAberta', 'ConsultaMarcasModeloPorGrupo', obj)
          .then((res) => {
            this.$vs.loading.close();
            if (res.data.length > 0) {
              this.isGrupoModelos = true;
              this.marcas = [];
              this.modelosAux = [];
              res.data.forEach((element) => {
                var aux = this.marcas.filter(
                  (x) => x.value.id == element.idMarca,
                );
                var auxModelos = this.modelosAux.filter(
                  (y) => y.value.id == element.idModelo,
                );
                if (aux.length == 0)
                  this.marcas.push({
                    value: {
                      id: element.idMarca,
                      valor: element.marca,
                      isGrupoModelos: true,
                    },
                    text: element.marca,
                  });

                if (auxModelos.length == 0)
                  this.modelosAux.push({
                    idMarca: element.idMarca,
                    idTipo: element.idTipo,
                    value: {
                      id: element.idModelo,
                      valor: element.modelo,
                      isGrupoModelos: true,
                    },
                    text: element.modelo,
                  });
              });
              this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
              this.marcas.unshift({id: null, text: 'Selecione'});
            } else {
              this.isGrupoModelos = false;
              this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
            }
          });
      } else {
        if (this.idGrupo == null) {
          this.desabilitaAlterarMarca = true;
          this.desabilitaAlterarAnoModelo = true;
          this.desabilitaAlterarModelo = true;
          this.desabilitaAlterarAnoFabricacao = true;
        } else {
          this.desabilitaAlterarMarca = false;
        }
      }
    },
    preencheModelo() {
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      if (this.idMarca) {
        this.form.veiculo.marca = this.idMarca.value
          ? this.idMarca.value
          : this.idMarca.text;
        this.form.veiculo.codigoMarca = this.idMarca.value
          ? this.idMarca.value.id
          : this.idMarca.id;
      } else {
        this.form.veiculo.marca = null;
        this.form.veiculo.codigoMarca = null;
        this.idModelo = null;
        this.idAnoModelo = null;
        this.idAnoFabricacao = null;
      }
      this.form.veiculo.modelo = null;
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoFabricacao = null;

      this.desabilitaAlterarAnoModelo = false;
      this.desabilitaAlterarModelo = false;

      this.form.cilindradas = null;
      this.selecionaTipo();

      if (!this.form.veiculo.marca.isGrupoModelos) {
        this.buscaDadosFipe('ConsultarModelos', 'modelos', 'name', 'id');
      } else {
        this.modelos = this.modelosAux.filter(
          (x) => x.idMarca == this.form.veiculo.marca.id,
        );
      }
    },
    async preencheAnos() {
      if (!this.idModelo) {
        this.idAnoFabricacao = null;
        return;
      }

      this.form.veiculo.modelo = this.idModelo.value;
      this.form.veiculo.anoGeral = null;
      this.anosModelo = [];
      this.form.cilindradas = null;
      this.idAnoFabricacao = null;
      if (this.form.veiculo.marca.isGrupoModelos == true) {
        var modeloAux = this.modelosAux.find(
          (x) => x.value.id == this.form.veiculo.modelo.id,
        );
        this.form.veiculo.tipoVeiculo = modeloAux.idTipo;
      }

      this.form.veiculo.codigoModelo = this.form.veiculo.modelo.id;
      await this.buscaDadosFipe(
        'ConsultarAnoModelo',
        'anosModelo',
        'name',
        'id',
      );

      var auxAnos = [];

      this.anosModelo.forEach((element) => {
        if (element.value) {
          var ano = element.value.valor.split(' ')[0];
          var combustivel = element.value.valor.split(' ')[1];
          var codigoTipoCombustivel = element.value.id.split('-')[1];
          if (ano <= new Date().getFullYear() + 1) {
            // this.anosFabricacao.push({
            //   value: ano,
            //   text: ano,
            // });
            auxAnos.push({
              value: {
                ano: ano,
                combustivel: combustivel,
                codigoTipoCombustivel: codigoTipoCombustivel,
              },
              text: element.value.valor.includes('32000')
                ? '0km'
                : element.value.valor,
            });
          }
        }
      });
      this.anosModelo = auxAnos;
    },
    selecionaAnoModelo() {
      if (this.idAnoModelo == null) {
        this.$emit('option:deselected', this.preencheModelo());
        this.idModelo = null;
        this.idAnoFabricacao = null;
      } else {
        this.form.veiculo.anoGeral = this.idAnoModelo.value;
        this.form.veiculo.ano = this.form.veiculo.anoGeral.ano;
        this.form.veiculo.codigoTipoCombustivel =
          this.form.veiculo.anoGeral.codigoTipoCombustivel;
        this.form.veiculo.anoModelo = this.form.veiculo.anoGeral.ano;
        this.form.veiculo.combustivel = this.form.veiculo.anoGeral.combustivel;
        this.desabilitaAlterarAnoFabricacao = false;

        this.form.veiculo.anoFabricacao = null;
        this.form.cilindradas = null;
        this.idAnoFabricacao = [];
        this.anosFabricacao = [];

        let _anoFabricao = {
          value: this.form.veiculo.anoModelo - 1,
          text: this.form.veiculo.anoModelo - 1,
        };

        if (this.form.isZero) {
          _anoFabricao = {};
        }

        this.anosFabricacao = [
          {
            value: this.form.veiculo.anoModelo,
            text:
              this.form.veiculo.anoModelo == '32000'
                ? '0km'
                : this.form.veiculo.anoModelo,
          },
          {
            ..._anoFabricao,
          },
        ];

        this.buscaDadosFipe(
          'ConsultarModelosPorAno',
          'modelosPorAno',
          'name',
          'id',
        );
      }
    },
    async buscaValorFipe() {
      this.form.veiculo.anoFabricacao = this.idAnoFabricacao.value;
      await this.buscaDadosFipe(
        'ConsultarValorComTodosParametros',
        'form.veiculo.resultFipe',
        '',
        '',
      );
      await this.marcaGrupoPorModelo();
      this.calcularCoberturaConjunto();
      //this.abrirModalGrupos();
    },
    async buscaDadosFipe(action, array, campoDescricao, campoPK) {
      return new Promise(async (resolve) => {
        this.$vs.loading();

        var formFipe = {
          idEmpresa: !this.$route.params.idEmpresa
            ? this.form.idEmpresa
            : this.$route.params.idEmpresa,
          codigoTabelaReferencia: this.codigoTabelaReferencia,
          codigoTipoVeiculo:
            this.form.veiculo.tipoVeiculo || this.idTipoFipe.id,
          codigoMarca: this.form.veiculo.codigoMarca,
          ano:
            this.form.veiculo.anoModelo +
            '-' +
            this.form.veiculo.codigoTipoCombustivel,
          codigoTipoCombustivel: this.form.veiculo.codigoTipoCombustivel,
          anoModelo: this.form.veiculo.anoModelo,
          codigoModelo: this.form.veiculo.codigoModelo,
        };
        service
          .post('Fipe', `${action}`, formFipe)
          .then((res) => {
            var arrayRes = res.data;
            this[array] = [];
            if (array == 'form.veiculo.resultFipe') {
              this.form.veiculo.resultFipe = arrayRes;
              this.$vs.loading.close();
              resolve();
              return;
            }
            // this[array].push({ text: 'Selecione', value: null });

            if (array == 'modelos') {
              this.modelos = [];
              arrayRes[0].forEach((element) => {
                this.modelos.push({
                  value: {id: element['id'], valor: element['name']},
                  text: element['name'],
                });
              });
              this.anosModelo = [];
              arrayRes[1].forEach((element) => {
                let _combustivel = element.name.split(' ')[1];

                if (this.idTipoFipe.id == 2) {
                  _combustivel = '';
                }

                if (this.idTipoFipe.id == 3) {
                  _combustivel = 'Diesel';
                }

                this.anosModelo.push({
                  value: {
                    ano: element.name.split(' ')[0],
                    combustivel: element.name.split(' ')[1],
                    codigoTipoCombustivel: element.id.split('-')[1],
                  },
                  text: element.name.includes('32000')
                    ? `0km ${_combustivel}`
                    : element.name,
                });
              });
            } else if (array == 'modelosPorAno') {
              this.modelos = [];
              arrayRes.forEach((element) => {
                this.modelos.push({
                  value: {id: element['id'], valor: element['name']},
                  text: element['name'],
                });
              });
            } else {
              arrayRes.forEach((element) => {
                if (array == 'codigoTabelaReferencia') {
                  this[array] = element[campoPK];
                } else
                  this[array].push({
                    value: {
                      id: element[campoPK],
                      valor: element[campoDescricao],
                    },
                    text: element[campoDescricao],
                  });
              });
            }
            this.$vs.loading.close();
            resolve();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Ocorreu um erro, por favor tente novamente!`,
              color: 'danger',
            });
          });
      });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({id: null, label: 'Selecione'});
      });
    },
    async selecionaTipoFipe() {
      if (!this.idTipoFipe) return;
      this.habilitaAlterarGrupo = false;
      this.idGrupo = {};
      this.marcas = [];
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      this.idMarca = null;
      this.idModelo = null;
      this.idAnoModelo = null;
      this.idAnoFabricacao = null;
      this.desabilitaAlterarMarca = true;
      this.desabilitaAlterarAnoModelo = true;
      this.desabilitaAlterarModelo = true;
      this.desabilitaAlterarAnoFabricacao = true;
      this.propostaParaSomenteAgregado = false;
      this.grupos = [];

      await this.buscaDadosGrupos();

      if (!this.placaEncontrada) {
        this.desabilitaAlterarMarca = false;
        this.habilitaAlterarGrupo = true;
        if (this.idTipoFipe) {
          this.buscaMarcasPorTipoVeiculo(this.idTipoFipe);
          this.form.veiculo.tipoVeiculo = this.idTipoFipe.id;
          // this.abrirModalGrupos();
        }
      }

      if (this.idTipoFipe) {
        const _tipoFipe = this.idTipoFipe.id;
        const tipoCaminhao = _tipoFipe === 3 ? true : false;
        this.form.caminhao = tipoCaminhao;
      }
    },
    buscaDadosTipos() {
      return new Promise(async (resolve) => {
        service.getAll('g/domTipoFipe', {}, 'list/').then((res) => {
          res.data.forEach((element) => {
            if (!element.deletedAt)
              this.tipos.push({
                id: element.idTipoFipe,
                label: element.nomeTipo,
              });
          });
          resolve();
        });
      });
    },
    async buscaDadosGrupos() {
      return new Promise(async (resolve) => {
        this.$vs.loading();
        service
          .getAll('Grupo', {}, 'list/' + this.form.idEmpresa)
          .then((res) => {
            if (this.grupos == undefined || this.grupos == null)
              this.grupos = [];

            if (!this.idTipoFipe.id) {
              this.idTipoFipe = this.idTipoFipeAux;
            }

            res.data.forEach((element) => {
              if (!element.deletedAt) {
                if (
                  element.idTipoFipe == this.idTipoFipe.id &&
                  this.propostaParaSomenteAgregado == false
                ) {
                  this.grupos.push({
                    id: element.idGrupo,
                    label: element.nomeGrupo,
                    descricao: element.descricao,
                    importado: element.importado,
                    idTipoFipe: element.idTipoFipe,
                    descricaoProdutos: element.descricaoProdutos,
                    permiteAgregado: element.permiteAgregado,
                    permiteSomenteAgregado: element.permiteSomenteAgregado,
                    permiteImplemento: element.permiteImplemento,
                    gruposAgregados: element.permiteAgregado
                      ? element.gruposAgregados
                      : null,
                  });
                }

                if (
                  this.propostaParaSomenteAgregado &&
                  element.permiteSomenteAgregado
                ) {
                  this.grupos.push({
                    id: element.idGrupo,
                    label: element.nomeGrupo,
                    descricao: element.descricao,
                    importado: element.importado,
                    idTipoFipe: element.idTipoFipe,
                    descricaoProdutos: element.descricaoProdutos,
                    permiteAgregado: element.permiteAgregado,
                    permiteSomenteAgregado: element.permiteSomenteAgregado,
                    permiteImplemento: element.permiteImplemento,
                    gruposAgregados: element.permiteAgregado
                      ? element.gruposAgregados
                      : null,
                  });
                }
              }
            });

            this.$vs.loading.close();
            resolve();
          })
          .catch((e) => notify.notifyFail(this.$vs, e));
      });
    },
    abrirModalGrupos() {
      if (!this.idTipoFipe) return;

      if (this.grupos.length > 1) {
        this.gruposPorTipo = this.grupos;
        this.mostrarModalGrupos = true;
      }
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado) {
        this[array] = [];
        this.cidade = null;
        return;
      }

      this.$vs.loading();
      this[array] = [];
      if (this.estado && this.estado.id) {
        this.$vs.loading();

        service
          .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
          .then((res) => {
            if (res)
              res.data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });
      }
    },
    buscaRestricoes() {
      return new Promise(async () => {
        this.$vs.loading();
        service
          .getAll('Restricoes', {}, `list/${this.form.idEmpresa}`)
          .then((res) => {
            var aux = res.data.filter((x) => x.deletedAt == null);
            this.restricoes = aux;
            this.restricoes.push({
              idRestricao: null,
              descricao: 'Nenhuma Restrição',
            });
            this.$vs.loading.close();
          });
      });
    },
    capturaParamsUtm() {
      const utmData = this.$route.query;
      const arrUtmData = Object.entries(utmData);

      let arrInsert = [];

      arrUtmData.forEach((element) => {
        let chave = element[0];
        let valor = element[1];
        let objInsert = {
          utm: chave,
          valorUtm: valor,
        };
        arrInsert.push(objInsert);
      });
      this.form.dadosUtm = arrInsert;
    },

    async GerarPropostaSite() {
      try {
        this.atribuirTipoPessa();
        this.quotationData.quotationType = this.form.tipoProposta.label;
        this.quotationData.contractType = this.form.tipoContrato.label;
        this.quotationData.beginningValidity = this.form.inicioVigencia;
        this.quotationData.endingValidity = this.form.fimVigencia;
        this.quotationData.groupId = this.quotationData.vehicles[0].groupId;
        this.quotationData.observation = null;

        this.quotationData.prospect.type = this.form.tipoPessoa;
        this.quotationData.prospect.name = this.form.nome;
        this.quotationData.prospect.nomeSocial = this.form.nomeSocial;
        this.quotationData.prospect.nomeCivil = this.form.nomeCivil;
        this.quotationData.prospect.email = this.form.email;
        this.quotationData.prospect.taxId = this.form.cpfcnpj;
        this.quotationData.prospect.phone = this.form.telefone;
        this.quotationData.prospect.cellphone = this.form.celular;
        this.quotationData.prospect.number = this.form.numero;
        this.quotationData.prospect.complement = this.form.complemento;
        this.quotationData.prospect.state = this.form.estado;
        this.quotationData.prospect.city = this.form.cidade;
        this.quotationData.prospect.address = this.form.endereco;
        this.quotationData.prospect.neighborhood = this.form.bairro;
        this.quotationData.prospect.zipCode = this.form.cep;

        this.btnBlock = true;

        var msg = '';
        if (msg != '') {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: msg.toString(),
            color: 'danger',
          });

          this.btnBlock = false;
        } else {
          this.btnBlock = true;

          this.$vs.loading();
          this.form.dadosFinanceiros.mensais = this.listaProdutosMensais;
          this.form.dadosFinanceiros.avista = this.listaProdutosAAvista;
          this.form.jsonFacilitadorProdutos = JSON.stringify(this.produtos);

          const quotationCreated = await quotationApi.createRcvatQuotation(
            this.quotationData,
          );
          let linkRelativo = window.location.origin;

          this.idPreCotacao &&
          this.convertePreCotacao({
            idEmpresa: this.idEmpresa,
            idProposta: quotationCreated.quotationId,
          });
          let pageTo = 'proposta';
          if (this.isLanding) {
            pageTo = 'propostasBP';
          }
          if (this.isInterno == false) {
            if (this.isRedirect) {
              window.parent.location.href = `${linkRelativo.replace(
                'app.',
                'adm.',
              )}/${pageTo}/${res.data.chave}`;
            } else
              window.location.href = `${linkRelativo.replace(
                'app.',
                'adm.',
              )}/${pageTo}/${res.data.chave}`;
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Cotação adicionada com sucesso',
              color: 'success',
            });
            this.$router.push('/Cotacoes');
          }

          this.$vs.loading.close();
          this.capturaParamsUtm();
        }

        this.btnBlock = false;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao gerar cotação',
          color: 'danger',
        });
      }
    },
    convertePreCotacao(data) {
      service
        .put('PreCotacao', 'ConverterPreCotacao', {
          idEmpresa: data.idEmpresa,
          idPropostaConvertida: data.idProposta,
          idPreCotacao: this.idPreCotacao,
        })
        .then(() => {
          this.carregando = false;
        })
        .catch((e) => {
          this.carregando = false;
          this.passo = 6;
          this.resultNegativo = true;
          this.msgNegativo = e;

          this.$bvToast.toast(e, {
            title: 'Atenção!',
            solid: true,
            variant: 'danger',
            toaster: 'b-toaster-top-full',
            appendToast: false,
            autoHideDelay: 5000,
          });
        });
    },

    validaConfiguracaoCaminhao() {
      this.validaImplementosAgregados = false;
      this.msgValidacaoImplementoAgregado = '';

      const configuracaoAgregado = this.form.agregado;
      const configuracaoImplemento = this.form.implemento;

      if (configuracaoAgregado || configuracaoImplemento) {
        const temAgregados = this.form.agregados.length;
        const temImplemento = this.form.implementos.length;

        const msgValidaAgregado =
          temAgregados == 0 && configuracaoAgregado
            ? 'É necessario adicionar um agregado'
            : '';

        if (msgValidaAgregado && temAgregados == 0) {
          this.msgValidacaoImplementoAgregado = msgValidaAgregado;
          this.validaImplementosAgregados = true;
          // this.btnDisabled2 = true;

          return false;
        }

        if (msgValidaAgregado == '' && temAgregados > 0) {
          this.btnDisabled2 = false;
        }

        const msgValidaImplemento =
          !temImplemento && configuracaoImplemento
            ? 'É necessario adicionar um Implemento'
            : '';

        if (msgValidaImplemento && temImplemento == 0) {
          this.msgValidacaoImplementoAgregado = msgValidaImplemento;
          this.validaImplementosAgregados = true;
          // this.btnDisabled2 = true;

          return false;
        }

        if (msgValidaImplemento == '' && temImplemento > 0) {
          this.btnDisabled2 = false;
        }
      }

      if (this.form.agregado === false && this.form.agregados.length > 0) {
        this.form.agregados = [];
      }

      if (this.form.implemento === false && this.form.implementos.length > 0) {
        this.form.implementos = [];
      }

      return true;
    },

    async buscar() {
      const valido = await this.$validator.validateAll();

      if (!valido) {
        return;
      }

      if (this.quotationData.vehicles.length == 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'É obrigatório a seleção de produtos RCVAT',
          color: 'danger',
        });
        return;
      }

      this.capturaParamsUtm();

      // montar increases
      let increases = this.form.agravos.map((increase) => {
        const key = Object.keys(increase)[0];
        return {
          increaseId: increase[key].idAgravo,
          increaseAnswerId: increase[key].idRespostaAgravo,
        };
      });

      this.quotationData.increases = increases;

      // montar charges
      let charges = [
        {
          idCharge: this.form.carregamentos.Corretagem.idCarregamento,
          percentage: parseFloat(
            this.form.carregamentos.Corretagem.porcentagem,
          ),
        },
      ];
      this.quotationData.charges = charges;

      // montar os params
      const params = {
        increases: this.quotationData.increases,
        charges: this.quotationData.charges,
        vehicles: this.quotationData.vehicles,
        beginningValidity: this.form.inicioVigencia,
        endingValidity: this.form.fimVigencia,
      };

      const calculate = await quotationApi.calculate(params);
      this.total = calculate.total;
      this.thirdStep = true;
      this.recalcularValorProdutos = false;
      this.generateQuotation = true;
    },
    async defineRota() {
      if (this.$route.path == '/auto/cotacao') {
        this.idTipoApolice = TIPO_APOLICE.AUTO;
        this.isInterno = true;
        const token = localStorage.getItem('user-token');
        if (token) {
          this.decoded = jwt.decode(token);
          this.form.idEmpresa = this.decoded.id_empresa;
          this.form.idUsuarioConsultor = this.decoded.id_usuario;
        }
        this.id_usuario = this.decoded.id_usuario;
      } else if (this.$route.path == '/rcvat/cotacao') {
        this.idTipoApolice = 2;
        this.isInterno = true;
        const token = localStorage.getItem('user-token');
        if (token) {
          this.decoded = jwt.decode(token);
          this.form.idEmpresa = this.decoded.id_empresa;
          this.form.idUsuarioConsultor = this.decoded.id_usuario;
        }
        this.id_usuario = this.decoded.id_usuario;
      }

      if (this.$route.query.insideApp) {
        this.insideApp = true;
        //await this.buscaDadosEmpresa();
      }

      if (this.$route.params.userName) {
        this.isPropostaConsultor = true;
        //await this.buscaDadosEmpresa();
        await this.buscaDadosConsultor();
      }

      if (this.$route.query.idPreCotacao) {
        this.idPreCotacao = this.$route.query.idPreCotacao;
      }

      if (this.isInterno) {
        this.exibeItensObrigatoriosB2C = true;
      } else {
        this.exibeItensObrigatoriosB2C = false;
      }

      // @Alternar empresa 117 para 118
      if (this.$route.params.idEmpresa == 117) {
        const {fullPath} = this.$route;
        const newRouter = fullPath.replace('117', '118');

        this.$router.replace(newRouter);
      }

      this.buscaDadosRegionais();
    },
    buscaDadosConsultor() {
      return new Promise((resolve, reject) => {
        var objSend = {
          idEmpresa: this.form.idEmpresa,
          userName: this.$route.params.userName,
        };
        service
          .post('Usuario', 'buscarUsuario', objSend)
          .then((res) => {
            this.dadosConsultor = res.data[0];
            this.form.idUsuarioConsultor = res.data[0].idUsuario;
            this.id_usuario = res.data[0].idUsuario;
            this.form.origem = 'B2C';

            resolve();
          })
          .catch((e) => {
            this.erroConexao =
              'Seu aplicativo parece estar offline, verifique sua conexao';
            reject(e);
          });
      });
    },
    buscaRegionais() {
      service
        .getAll('Usuario', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.idUsuario == this.id_usuario) {
              if (element.usuarios_regionais.length > 0) {
                this.usuarios_regionais = element.usuarios_regionais;
                this.usuarios_regionais.forEach((elementSel) => {
                  this.regionais.push({
                    id: elementSel.idRegional,
                    label: elementSel.nome,
                  });
                });
              } else {
                var usuarios_regionais = element.Usuarios_Regional;
                this.regionais.push({
                  id: usuarios_regionais.idRegional,
                  label: usuarios_regionais.nome,
                });
              }
              this.regionalDefault = this.regionais[0];
            }
          });
        });
    },
    buscaDadosEmpresa() {
      return new Promise((resolve, reject) => {
        service
          .getAll('g', {}, 'empresas/list/idEmpresa/' + this.form.idEmpresa)
          .then((res) => {
            this.permitirRestricoes = res.data[0].permitirRestricoes;
            this.permitePlacaRepetida =
              res.data[0].permiteVariasCotacoesPorPlaca;
            this.alterarGrupoVeiculoCotacao =
              res.data[0].alterarGrupoVeiculoCotacao;

            if (this.alterarGrupoVeiculoCotacao)
              this.habilitaAlterarGrupo = true;

            this.logo = res.data[0].logo;
            resolve();
          })
          .catch((e) => {
            this.erroConexao =
              'Seu aplicativo parece estar offline, verifique sua conexao';
            reject(e);
          });
      });
    },
    buscaProdutosSobrepoeFaltante() {
      var arrFaltante = [];
      this.produtosObrigatorios.forEach((element) => {
        var aux = this.form.produtosSelecionados.find(
          (x) => x.id == element.id_produto,
        );
        if (!aux) arrFaltante.push(element);
      });
      if (arrFaltante.length > 0) {
        var arrEncontrou = [];
        arrFaltante.forEach((elementFaltante) => {
          this.form.produtosSelecionados.forEach((element) => {
            var aux = this.produtos.find((x) => x.id_produto == element.id);
            if (aux.sobreporOutrosProdutos) {
              var prodssobreporOutrosProdutos =
                aux.sobreporOutrosProdutos.split(',');
              var aux2 = prodssobreporOutrosProdutos.filter(
                (x) => x == elementFaltante.id_produto,
              );
              if (aux2.length > 0) {
                arrEncontrou.push(aux2[0]);
              }
            }
          });
          if (arrEncontrou.length == 0) {
            this.form.produtosSelecionados.push(elementFaltante);
          }
        });
      }
    },
    validaSelecionado(item) {
      var aux = this.form.produtosSelecionados.filter(
        (x) => x.id == item.id_produto,
      );
      if (item.obrigatorio && aux.length > 0) return true;
      else if (item.obrigatorio && aux.length == 0) return false;
      return false;
    },
    selecionaProduto(item) {
      // sobrepoe produtos
      if (item.sobreporOutrosProdutos) {
        var prodssobreporOutrosProdutos =
          item.sobreporOutrosProdutos.split(',');
        prodssobreporOutrosProdutos.forEach((element) => {
          this.form.produtosSelecionados.forEach((elementSel, index) => {
            if (elementSel.id == element) {
              this.form.produtosSelecionados.splice(index, 1);
            }
          });
        });
      } else {
        this.produtos.forEach((element) => {
          if (element.sobreporOutrosProdutos) {
            var prodssobreporOutrosProdutos =
              element.sobreporOutrosProdutos.split(',');
            var aux = prodssobreporOutrosProdutos.find(
              (x) => x == item.id_produto,
            );
            if (aux) {
              this.form.produtosSelecionados.forEach((selecionado, index) => {
                if (selecionado.id == element.id_produto) {
                  this.form.produtosSelecionados.splice(index, 1);
                }
              });
            }
          }
        });
      }
      this.buscaProdutosSobrepoeFaltante();
      if (item.ismensal == false) this.buscaFormasPagamento();

      // produtos linkados
      if (item.produtosLinkados) {
        const produtosLinkados = item.produtosLinkados.split(',');

        produtosLinkados.forEach((id) => {
          const produtoLinkado = this.produtos.find(
            (produto) => produto.id_produto == id,
          );

          if (produtoLinkado) {
            const existeSelecionado = this.form.produtosSelecionados.find(
              (item) => item.id_produto === produtoLinkado.id_produto,
            );

            if (!existeSelecionado) {
              this.form.produtosSelecionados.push(produtoLinkado);
            } else {
              this.form.produtosSelecionados.forEach((elementSel, index) => {
                if (elementSel.id_produto === produtoLinkado.id_produto)
                  this.form.produtosSelecionados.splice(index, 1);
              });
            }
          }
        });
      }
    },
    abrirModalImplemento() {
      // this.placaVeiculoTratorSelecionado= null;
      // this.chassiVeiculoTratorSelecionado= null;

      // this.placaVeiculoTratorSelecionado= this.form.placa;
      // this.chassiVeiculoTratorSelecionado= this.form.chassi;

      this.modalImplemento = true;
      this.resetFormImplemento = false;
    },
    abrirModalComplemento() {
      // this.placaVinculoSelecionado = null;
      // this.chassiVinculoSelecionado = null;

      // this.placaVinculoSelecionado = this.form.placa;
      // this.chassiVinculoSelecionado = this.form.chassi;
      this.idGrupoVinculoAgregado = this.idGrupo.id;
      this.modalComplemento = true;
      this.resetFormComplemento = false;
    },
    buscaDivisoes() {
      return new Promise((resolve) => {
        if (this.form.regional) {
          var objSend = {
            idRegional: this.form.regional.id,
            idUsuario: this.id_usuario,
          };
          this.$vs.loading();
          service.post('CotacaoAberta', 'BuscaDivisao', objSend).then((res) => {
            this.divisoes = [];
            res.data.forEach((element) => {
              this.divisoes.push({
                id: element.id_divisao,
                label: element.nome_divisao,
              });
            });
            this.$vs.loading.close();
            this.buscouDivisoes = true;
            //this.buscouDivisoes();
            resolve();
          });
        }
      });
    },
    buscaPreCotacao() {
      const id = this.idPreCotacao;
      service
        .post('PreCotacao', 'buscarPreCotacao', {idPreCotacao: id})
        .then((res) => {
          res.data.resultado[0].idPropostaConvertida
            ? this.preCotacaoCovertida()
            : this.atribuiDadosPreCotacao(res.data.resultado[0]);
          this.$vs.loading.close();
        })
        .catch(() => {
        });
    },
    atribuiDadosPreCotacao(data) {
      this.form.nome = data.nome;
      this.form.nomeSocial = data.nomeSocial;
      this.form.nomeCivil = data.nomeCivil;
      this.form.celular = data.celular;
      this.form.email = data.email;
      this.form.estado = data.estado;
      this.estado = data.estado;
      this.form.cidade = data.cidade;
      this.cidade = data.cidade;
      this.form.tipoProposta = 'Adesão';
      this.form.idGrupo.id = data.jsonRetorno.grupoSeleciondo.id;
      this.form.idGrupo.valor = data.jsonRetorno.grupoSeleciondo.label;
      if (
        typeof data.jsonRetorno.dadosPlaca === 'object' &&
        Object.hasOwn(data.jsonRetorno.dadosPlaca, 'placa')
      ) {
        let placa = data.jsonRetorno.dadosPlaca.placa.split('');
        placa.splice(3, 0, '-');
        placa = placa.join('');
        this.form.placa = placa;
        this.buscaPlacaFipe();
      }
    },
    preCotacaoCovertida() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Essa Pre Cotação já foi covertida em uma cotação',
        color: 'danger',
      });
      this.$router.go(-1);
    },
    fecharModal() {
      this.mostrarModalGrupos = false;
    },
    fecharModalPlaca() {
      this.modalPlacaRecusada = false;

      if (this.buscouProdutos) {
        this.passo = 1;
        this.produtos = [];
        this.produtosNaoObrigatorios = [];
        this.produtosObrigatorios = [];
        this.placaEncontrada = false;
        this.resetBuscaPlaca();
        this.buscouProdutos = false;
      }

      if (this.codigoSituacao === '999') {
        this.form.placa = '';
        this.fipeEncontrada = false;
        this.placaEncontrada = false;
      }
    },
    converteParams() {
      if (this.$route.query.hideLogo) {
        this.hideLogo = JSON.parse(this.$route.query.hideLogo.toLowerCase());
      } else this.hideLogo = false;

      if (this.$route.query.showPanel) {
        this.showPanel = JSON.parse(this.$route.query.showPanel.toLowerCase());
      } else this.showPanel = true;

      if (this.$route.query.fixedButton) {
        this.fixedButton = JSON.parse(
          this.$route.query.fixedButton.toLowerCase(),
        );
      } else this.fixedButton = false;

      if (this.$route.query.isRedirect) {
        this.isRedirect = JSON.parse(
          this.$route.query.isRedirect.toLowerCase(),
        );
      } else this.isRedirect = true;
    },
    selecionaGrupo() {
      this.form.veiculo.idGrupo = this.idGrupo.id;
      this.form.idGrupo.id = this.idGrupo.id;
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.form.idEmpresa);
    },
    chassiToUpperCase(chassi) {
      if (chassi) {
        this.form.chassi = chassi.toUpperCase();
      }
    },
    verificaCelular(telefone) {
      telefone = telefone.replace(/\D/g, '');
      const regexSequencial = /(\d)\1{8}/;
      if (!(telefone.length >= 10 && telefone.length <= 11)) return false;

      //Se tiver 11 caracteres, verificar se começa com 9 o celular
      if (telefone.length == 11 && parseInt(telefone.substring(2, 3)) != 9) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }

      for (let n = 0; n < 10; n++) {
        if (
          telefone == new Array(11).join(n) ||
          telefone == new Array(12).join(n)
        ) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Digite um número de celular válido',
            color: 'warning',
          });
          return false;
        }
      }
      const codigosDDD = [
        11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
      ];
      if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2))) == -1) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (
        telefone.length == 10 &&
        [2, 3, 4, 5, 7].indexOf(parseInt(telefone.substring(2, 3))) == -1
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (regexSequencial.test(telefone)) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (this.dadosConsultor || this.consultorCelular) {
        let celularConsultor = '';
        let celularConsultor2 = '';
        this.dadosConsultor
          ? (celularConsultor = this.dadosConsultor.celular.replace(/\D/g, ''))
          : '';
        this.consultorCelular
          ? (celularConsultor2 = this.consultorCelular.replace(/\D/g, ''))
          : '';
        if (telefone == (celularConsultor || celularConsultor2)) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Digite um número de celular diferente do consultor.',
            color: 'danger',
          });
          return false;
        }
      }
      return true;
    },
    async buscaDadosConsultorAdm() {
      if (this.decoded) {
        this.$vs.loading();
        const objSend = {
          idEmpresa: this.decoded.id_empresa,
          userName: this.decoded.userName,
        };
        try {
          const res = await service.post('Usuario', 'buscarUsuario', objSend);
          this.consultorCelular = res.data[0].celular;
        } catch (error) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    buscarPlacasZerado() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Não foi possível buscar a placa, preencha os dados manualmente, ou tente novamente.',
        color: 'warning',
        timer: 10000,
      });
    },
    async buscaMarcasPorTipoVeiculo(tipoVeiculo) {
      let objSend = {
        tipoVeiculo: tipoVeiculo.id,
      };

      try {
        this.$vs.loading();
        const res = await service
          .post('Fipe', 'consultar-marcas-por-tipo-veiculo', objSend)
          .catch((error) => {
            this.$vs.loading.close();
          });

        this.marcas = res.data;
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao busca os dados, falha na conexão com a internet ou serviço indisponível. Tente novamente',
          color: 'danger',
          timer: 5000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async ajustarPropostaParaSomenteAgregado() {
      const _propostaParaSomenteAgregado = this.propostaParaSomenteAgregado;

      if (
        (this.placaEncontrada && _propostaParaSomenteAgregado) ||
        !_propostaParaSomenteAgregado
      ) {
        this.placaEncontrada = false;
        this.modelosFipeEncontrados = [];
        this.grupos = [];
        this.idGrupo = null;
      }

      this.idGrupo = {id: null, label: ''};

      // this.form.somenteAgregado = _propostaParaSomenteAgregado ? true : false;

      this.desabilitarInputVeiculoZero = _propostaParaSomenteAgregado
        ? true
        : false;

      this.idTipoFipeAux = _propostaParaSomenteAgregado
        ? {id: 3, label: 'Caminhão'}
        : {id: null, label: 'Selecione'};

      this.idTipoFipe = this.idTipoFipeAux;

      this.form.veiculo.tipoVeiculo = _propostaParaSomenteAgregado
        ? this.idTipoFipe.id
        : null;

      if (!this.idTipoFipe) this.idTipoFipe = this.idTipoFipe;

      if (_propostaParaSomenteAgregado) {
        this.grupos = [];
        await this.buscaDadosGrupos();
      }

      this.permitirSomenteAgregado = _propostaParaSomenteAgregado
        ? true
        : false;

      this.form.somenteAgregado = _propostaParaSomenteAgregado ? true : false;
      this.habilitaAlterarGrupo = _propostaParaSomenteAgregado ? false : true;

      if (this.grupos.length > 1 && _propostaParaSomenteAgregado) {
        this.mostrarModalGrupos = true;
        this.habilitaAlterarGrupo = false;
      }

      if (this.grupos.length == 1 && _propostaParaSomenteAgregado) {
        this.mostrarModalGrupos = false;
        this.habilitaAlterarGrupo = true;
        this.idGrupo = this.grupos[0];
      }
    },
    validarDataSaidaNf() {
      let dataValida = false;
      this.btnDisabled2 = true;
      const dataNfValida = this.form.dataNf.length == 10;
      let exibirAlerta = false;

      if (dataNfValida) {
        dataValida = dateConversion.verificarSaidaNotaFiscal(this.form.dataNf);
        this.btnDisabled2 = dataValida ? false : true;
        if (dataValida) {
          return dataValida;
        }
      }

      exibirAlerta = dataNfValida && !dataValida;
      this.modalInfoDataSaidaNf = exibirAlerta ? true : false;
    },
    validaIsLanding() {
      if (localStorage.getItem('estado')) {
        this.form.cep = localStorage.getItem('cep');
        this.form.bairro = localStorage.getItem('bairro');
        this.form.endereco = localStorage.getItem('endereco');
        this.form.cidade = localStorage.getItem('cidade');
        this.form.estado = localStorage.getItem('estado');
        this.form.tipoAtendimento = localStorage.getItem('tipoAtendimento');
      }
    },
    salvaProspect() {
      if (this.isLanding) {
        if (!this.form.nome) {
          return;
        }
        if (this.form.celular) {
          const validateCompleto = this.verificaCelular(this.form.celular);
          if (!validateCompleto) {
            return;
          }
        }
        if (this.form.nome && this.form.celular) {
          service
            .post('CotacaoAberta', 'SalvarLeadB2C', this.form)
            .then((res) => {
              this.form.idLead = res.data.idLead;
            });
        }
      }
    },
    exibirAlertaPlaca(dadosConsultaPlaca) {
      if (!dadosConsultaPlaca) return;

      const {
        nomeConsultorPlaca,
        regionalConsultorPlaca,
        modalPlacaRecusada,
        codigoSituacao,
        situacao,
      } = dadosConsultaPlaca;

      this.nomeConsultorPlaca = nomeConsultorPlaca;
      this.regionalConsultorPlaca = regionalConsultorPlaca;
      this.modalPlacaRecusada = modalPlacaRecusada;
      this.codigoSituacaoPlaca = codigoSituacao;
      this.situacaoPlaca = situacao;

      return;
    },
    async consultarExisteCotacao() {
      try {
        if (this.propostaParaSomenteAgregado) {
          return true;
        }

        const _identificadoVeiculo = this.form.placa || this.form.chassi;

        if (!_identificadoVeiculo) {
          this.$vs.loading.close();

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Uma placa ou chassi ou valido deve ser informado',
            color: 'danger',
          });

          return;
        }

        const tipoIdentificado =
          _identificadoVeiculo.length == 17 ? 'chassi' : 'placa';

        if (this.isPropostaConsultor || this.isInterno) {
          const dadosConsultaPlaca = await consultaPlaca({
            tipoIdentificado,
            identificador: this.form.placa || this.form.chassi,
            idEmpresa: this.form.idEmpresa,
            somenteAgregado: this.propostaParaSomenteAgregado,
            permitePlacaRepetida: this.permitePlacaRepetida,
          });

          if (dadosConsultaPlaca.codigoSituacao === '999') {
            this.$vs.loading.close();
            this.exibirAlertaPlaca(dadosConsultaPlaca);
            return false;
          }
        }

        return true;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      }
    },
    verificaChassiBaseBP: async function () {
      if (this.propostaParaSomenteAgregado && !this.form.chassi) {
        return;
      }

      if (this.form.chassi.length === 17) {
        this.placaValidada = await this.consultarExisteCotacao();

        if (!this.placaValidada) {
          return;
        }

        await this.consultarPlacaChassiBaseBP(null, 'chassi');
      }
    },
    async consultarPlacaChassiBaseBP(placa = null, chassi = null) {
      const isBP = functions.verificaEmpresaBemProtege(this.form.idEmpresa);

      if (!isBP || (!this.placaValidada && placa)) {
        return true;
      }

      const dadosConsultaPlaca = await buscarPlacaBaseBP({
        idEmpresa: this.form.idEmpresa,
        placa: placa ? this.form.placa : placa,
        chassi: chassi ? this.form.chassi : chassi,
      });

      if (dadosConsultaPlaca.codigoSituacao === '998') {
        this.$vs.loading.close();

        if (
          this.form.tipoProposta !== 'Reativação' &&
          this.form.tipoProposta !== 'Troca de Titularidade'
        ) {
          this.form.tipoProposta = null;
          this.exibirAlertaPlaca(dadosConsultaPlaca);
          return false;
        } else {
          return true;
        }
      }

      this.codigoSituacaoPlaca = '0';
      return true;
    },
    async getDominios() {
      try {
        const Promises = [
          this.utils.getTiposProposta(this.idTipoApolice),
          this.utils.getTiposContratos(),
          this.utils.getCarregamentos(),
          this.utils.getAgravos(this.idTipoApolice),
        ];

        const [
          listTiposProposta,
          listTiposContrato,
          listCarregamentos,
          listAgravos,
        ] = await Promise.all(Promises);

        this.listTiposProposta = listTiposProposta;
        this.listTiposContrato = listTiposContrato;
        this.listCarregamentos = listCarregamentos;
        this.listAgravos = listAgravos;

        this.form.carregamentos =
          this.utils.atribuirCarregamentosForm(listCarregamentos);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    atribuirTipoPessa() {
      const cpfcnpf = this.form.cpfcnpj;
      if (cpfcnpf.length === 14 || cpfcnpf.length === 18) {
        const validado = cpfcnpj.valida_cpf_cnpj(cpfcnpf);

        if (!validado) {
          notify.notifyFail(this.$vs, 'CPF OU CNPJ Inválido');
          return;
        }

        if (cpfcnpf.length === 14) {
          this.form.tipoPessoa = this.tiposPessoas[1].id;
        }

        if (cpfcnpf.length === 18) {
          this.form.tipoPessoa = this.tiposPessoas[2].id;
        }
      }
    },
    handleModelosEncontrados() {
      this.mostrarMaisModelosEncontrados = !this.mostrarMaisModelosEncontrados;
    },
  },

  async created() {
    await this.defineRota();
    this.buscaDadosEmpresa();
  },
  mounted() {
    this.defineRota();
    this.buscaDadosTipos();
    this.buscarDicionarioChassisNacionais();
    this.buscarDicionarioTiposVeiculos();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.buscaRestricoes();

    this.$validator.localize('ptBr', locale);
    this.converteParams();
    this.buscaDadosConsultorAdm();
    this.validaIsLanding();

    this.item = {};
    this.produtosObrigatorios = [];
    this.produtosNaoObrigatorios = [];
    this.form.produtosSelecionados = [];
    this.produtos.forEach((element) => {
      element.valorFinal = element.valor;
      element.descontoConcedido = 0;
      element.id = element.id_produto;
      if (element.obrigatorio == true) {
        this.produtosObrigatorios.push(element);
        this.form.produtosSelecionados.push(element);
      } else {
        this.produtosNaoObrigatorios.push(element);
      }
    });

    // carrega os dominios relacionados a cotação da seguradora
    this.getDominios();
  },
  components: {
    'v-select': vSelect,
    Money,
    cartaoCredito,
    FormComplemento,
    formDesconto,
    FormNovoValorProduto,
    flatPickr,
    CarregamentosForm,
    AgravosForm,
    ErrorsAlert,
    formProdutosRcvat,
    Modal
  },
};
</script>
<style lang="scss">
.form-landing {
  font-family: 'Roboto';
  padding-top: 60px;
  min-height: 80vh;

  .coluna-switch {
    padding: 0px 5px;

    div {
      background-color: #eff7ff;
      padding: 10px;
      min-height: 60px;
      vertical-align: middle;

      .label-switch {
        font-size: 12px;
        color: #078fcf;
      }
    }
  }

  label,
  .vs-input--label {
    color: #078fcf !important;
    font-size: 1rem;
  }

  .vs-input--input,
  .vs__dropdown-toggle,
  .vs-con-input .vs-inputx {
    height: 52px;
    background: white;
    border-radius: 9px;
    border: 1px #eeeeee solid !important;
  }
}

.botaoContratarAgora {
  background-color: #158c12;
  border-radius: 1rem;
  font-size: 1rem;
  color: #ffffff;
  padding: 1rem 2rem 1rem 2rem;
  transition: background-color 0.3s;
  font-family: 'Product Sans', sans-serif;
  cursor: pointer;
  border: 0;
  text-align: center;

  img {
    float: right;
    margin-top: 5px;
  }
}

.checkBoxNomeSocial {
  align-self: center;
}
</style>
<style scoped>
.input-data {
  width: 300px !important;
  max-width: 100% !important;
}

body {
  background-color: white;
}

.valorprod {
  color: #000;
  font-weight: bolder;
  font-family: 'roboto';
}

.con-slot-label {
  width: 100%;
  margin-left: 10px;
}

.semPadding {
  padding: 0em 0em 0em 0em !important;
}

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.my-custom-money {
  font-size: 1.5em;
  color: #555555;
}

.my-custom-money-danger {
  font-size: 1.5em;
  color: #ea5455;
}

.my-custom-input {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #b4b4b4;
  border-radius: 8px;
}

.my-custom-input-danger {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #ea5455;
  border-radius: 8px;
}

#meu-popup-personalizado.con-vs-popup .vs-popup {
  width: fit-content;
}
</style>
<style lang="scss" scoped>
.vs__search,
.vs__search:focus {
  padding: 0 6px !important;
}

.fixed-buttons {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ccc;
  padding: 10px;
  margin-left: -25px;
  background-color: #fff;
  z-index: 999;
}

.painel-no-border {
  box-shadow: none !important;
  padding-bottom: 70px;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 10px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.item-lista {
  border: 1px solid #ccc;
  padding: 15px;
}

.form-part-title {
  padding: 1em;
  background: #d8e2ff;

  span {
    color: #2b50bb;
    font-weight: 600;
  }
}

.input-data-ativacao {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.itemprodutos {
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  padding: 10px 0 10px;
}

.title-item-veiculo {
  border-bottom: 1px solid #000;
}

.vs-radio--circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  top: 0;
  background-color: #d8e2ff !important;
}
</style>
